//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class IdentityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(): Observable<void> {
        let url_ = this.baseUrl + "/identity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AnnouncementsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * get list of return code
     * @return IEnumerable of ViewModels.AnnouncementLink
     */
    get(): Observable<Announcement[]> {
        let url_ = this.baseUrl + "/announcements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Announcement[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Announcement[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Announcement[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Announcement[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Announcement[]>(null as any);
    }

    /**
     * updates the whole list of return codes
     * @return IEnumerable of viewModels.AnnouncementLink
     */
    updateAnnouncements(announcements: Announcement[]): Observable<Announcement[]> {
        let url_ = this.baseUrl + "/announcements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(announcements);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAnnouncements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAnnouncements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Announcement[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Announcement[]>;
        }));
    }

    protected processUpdateAnnouncements(response: HttpResponseBase): Observable<Announcement[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Announcement[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Announcement[]>(null as any);
    }
}

@Injectable()
export class AttachmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * search result for attachments
     * @param templateId (optional) Id
     * @param attachmentNum (optional) 
     * @param description (optional) 
     * @param includeArchived (optional) 
     * @return IEnumerable of ViewModels.Attachments
     */
    getAll(templateId?: number | null | undefined, attachmentNum?: string | null | undefined, description?: string | null | undefined, includeArchived?: boolean | null | undefined): Observable<Attachment[]> {
        let url_ = this.baseUrl + "/attachments?";
        if (templateId !== undefined && templateId !== null)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (attachmentNum !== undefined && attachmentNum !== null)
            url_ += "attachmentNum=" + encodeURIComponent("" + attachmentNum) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (includeArchived !== undefined && includeArchived !== null)
            url_ += "includeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Attachment[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Attachment[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Attachment[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Attachment[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Attachment[]>(null as any);
    }

    /**
     * Adds a new attachment
     * @return returns the saved attachment
     */
    post(attachment: PostAttachmentViewModel): Observable<Attachment> {
        let url_ = this.baseUrl + "/attachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(attachment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Attachment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Attachment>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<Attachment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Attachment;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Attachment>(null as any);
    }

    /**
     * Copy an attachment
     * @return returns the saved attachment
     */
    copy(id: number): Observable<Attachment> {
        let url_ = this.baseUrl + "/attachments/{id}/actions/copy";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Attachment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Attachment>;
        }));
    }

    protected processCopy(response: HttpResponseBase): Observable<Attachment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Attachment;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Attachment>(null as any);
    }

    /**
     * Get an attachment by Id
     * @param id id of attachment
     * @return attachment view model.
     */
    get(id: number): Observable<Attachment> {
        let url_ = this.baseUrl + "/attachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Attachment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Attachment>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Attachment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Attachment;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Attachment>(null as any);
    }

    /**
     * Updates an attachment
     */
    update(id: number, data: Attachment): Observable<Attachment> {
        let url_ = this.baseUrl + "/attachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Attachment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Attachment>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Attachment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Attachment;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Attachment>(null as any);
    }
}

@Injectable()
export class BookmarkFieldsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * returns bookmark fields.
     * @return IEnumerable of ViewModels.BookmarkFields
     */
    get(): Observable<BookmarkFields[]> {
        let url_ = this.baseUrl + "/bookmarkfields";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BookmarkFields[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BookmarkFields[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BookmarkFields[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BookmarkFields[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BookmarkFields[]>(null as any);
    }
}

@Injectable()
export class ContactListClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * get list of return code
     * @return IEnumerable of ViewModels.Contact
     */
    get(): Observable<UserContact[]> {
        let url_ = this.baseUrl + "/contactlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserContact[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserContact[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserContact[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserContact[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserContact[]>(null as any);
    }

    /**
     * updates the whole list of return codes
     * @return IEnumerable of viewModels.Contact
     */
    updateContacts(contacts: ContactList[]): Observable<ContactList[]> {
        let url_ = this.baseUrl + "/contactlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(contacts);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactList[]>;
        }));
    }

    protected processUpdateContacts(response: HttpResponseBase): Observable<ContactList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContactList[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactList[]>(null as any);
    }
}

@Injectable()
export class ReturnCodesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * get list of return code
     * @return IEnumerable of ViewModels.ReturnCode
     */
    get(): Observable<ReturnCode[]> {
        let url_ = this.baseUrl + "/returncodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnCode[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReturnCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReturnCode[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnCode[]>(null as any);
    }

    /**
     * updates the whole list of return codes
     * @return IEnumerable of viewModels.ReturnCode
     */
    updateReturnCodes(returnCodes: ReturnCode[]): Observable<ReturnCode[]> {
        let url_ = this.baseUrl + "/returncodes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(returnCodes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReturnCodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReturnCodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnCode[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnCode[]>;
        }));
    }

    protected processUpdateReturnCodes(response: HttpResponseBase): Observable<ReturnCode[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReturnCode[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnCode[]>(null as any);
    }
}

@Injectable()
export class ShortcutLinksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * get list of return code
     * @return IEnumerable of ViewModels.ShortcutLink
     */
    get(): Observable<ShortcutLink[]> {
        let url_ = this.baseUrl + "/shortcutlinks";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortcutLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortcutLink[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ShortcutLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortcutLink[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShortcutLink[]>(null as any);
    }

    /**
     * updates the whole list of return codes
     * @return IEnumerable of viewModels.ShortcutLink
     */
    updateShortcutLinks(shortcutLinks: ShortcutLink[]): Observable<ShortcutLink[]> {
        let url_ = this.baseUrl + "/shortcutlinks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(shortcutLinks);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateShortcutLinks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateShortcutLinks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShortcutLink[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShortcutLink[]>;
        }));
    }

    protected processUpdateShortcutLinks(response: HttpResponseBase): Observable<ShortcutLink[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortcutLink[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ShortcutLink[]>(null as any);
    }
}

@Injectable()
export class SubrecipientQuestionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(): Observable<SubrecipientQuestion[]> {
        let url_ = this.baseUrl + "/subrecipientquestions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubrecipientQuestion[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubrecipientQuestion[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SubrecipientQuestion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubrecipientQuestion[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubrecipientQuestion[]>(null as any);
    }

    updateQuestions(questions: SubrecipientQuestion[]): Observable<SubrecipientQuestion[]> {
        let url_ = this.baseUrl + "/subrecipientquestions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(questions);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateQuestions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateQuestions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubrecipientQuestion[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubrecipientQuestion[]>;
        }));
    }

    protected processUpdateQuestions(response: HttpResponseBase): Observable<SubrecipientQuestion[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubrecipientQuestion[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubrecipientQuestion[]>(null as any);
    }
}

@Injectable()
export class SubrecipientStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    getAllStatuses(): Observable<SubrecipientStatusVm[]> {
        let url_ = this.baseUrl + "/subrecipientstatus/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubrecipientStatusVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubrecipientStatusVm[]>;
        }));
    }

    protected processGetAllStatuses(response: HttpResponseBase): Observable<SubrecipientStatusVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubrecipientStatusVm[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubrecipientStatusVm[]>(null as any);
    }

    getActiveStatuses(): Observable<SubrecipientStatusVm[]> {
        let url_ = this.baseUrl + "/subrecipientstatus/active";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubrecipientStatusVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubrecipientStatusVm[]>;
        }));
    }

    protected processGetActiveStatuses(response: HttpResponseBase): Observable<SubrecipientStatusVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubrecipientStatusVm[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubrecipientStatusVm[]>(null as any);
    }

    updateSubrecipientStatuses(subrecipientStatuses: SubrecipientStatusVm[]): Observable<SubrecipientStatusVm[]> {
        let url_ = this.baseUrl + "/subrecipientstatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subrecipientStatuses);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSubrecipientStatuses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSubrecipientStatuses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubrecipientStatusVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubrecipientStatusVm[]>;
        }));
    }

    protected processUpdateSubrecipientStatuses(response: HttpResponseBase): Observable<SubrecipientStatusVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubrecipientStatusVm[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubrecipientStatusVm[]>(null as any);
    }
}

@Injectable()
export class TrainingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * get list of return code
     * @return IEnumerable of ViewModels.AnnouncementLink
     */
    getAll(): Observable<Training[]> {
        let url_ = this.baseUrl + "/trainings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Training[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Training[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Training[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Training[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Training[]>(null as any);
    }

    /**
     * updates the whole list of return codes
     * @return IEnumerable of viewModels.AnnouncementLink
     */
    updateTraining(training: Training): Observable<Training> {
        let url_ = this.baseUrl + "/trainings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(training);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTraining(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTraining(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Training>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Training>;
        }));
    }

    protected processUpdateTraining(response: HttpResponseBase): Observable<Training> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Training;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Training>(null as any);
    }

    /**
     * updates the whole list of return codes
     * @return IEnumerable of viewModels.AnnouncementLink
     */
    deleteTraining(id: number): Observable<Training> {
        let url_ = this.baseUrl + "/trainings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTraining(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTraining(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Training>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Training>;
        }));
    }

    protected processDeleteTraining(response: HttpResponseBase): Observable<Training> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Training;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Training>(null as any);
    }

    /**
     * Gets the id and name from files table
     * @return IEnumerable of ViewModels.AnnouncementLink
     */
    get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/trainings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class UtilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    getAllUtilityLookupTables(): Observable<UtilityTableLookupVm[]> {
        let url_ = this.baseUrl + "/utility/utilitytables";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUtilityLookupTables(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUtilityLookupTables(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UtilityTableLookupVm[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UtilityTableLookupVm[]>;
        }));
    }

    protected processGetAllUtilityLookupTables(response: HttpResponseBase): Observable<UtilityTableLookupVm[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UtilityTableLookupVm[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UtilityTableLookupVm[]>(null as any);
    }

    getAllLookupItems(utilityKey?: string | null | undefined): Observable<LookupItemsResponse> {
        let url_ = this.baseUrl + "/utility/utilityitems?";
        if (utilityKey !== undefined && utilityKey !== null)
            url_ += "utilityKey=" + encodeURIComponent("" + utilityKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllLookupItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllLookupItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupItemsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupItemsResponse>;
        }));
    }

    protected processGetAllLookupItems(response: HttpResponseBase): Observable<LookupItemsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupItemsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupItemsResponse>(null as any);
    }

    get(id: number, utilityKey?: string | undefined): Observable<LookupItemResponse> {
        let url_ = this.baseUrl + "/utility/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (utilityKey === null)
            throw new Error("The parameter 'utilityKey' cannot be null.");
        else if (utilityKey !== undefined)
            url_ += "utilityKey=" + encodeURIComponent("" + utilityKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupItemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupItemResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LookupItemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupItemResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupItemResponse>(null as any);
    }

    delete(id: number, utilityKey?: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/utility/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (utilityKey === null)
            throw new Error("The parameter 'utilityKey' cannot be null.");
        else if (utilityKey !== undefined)
            url_ += "utilityKey=" + encodeURIComponent("" + utilityKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    post(lookupItem: LookupItem, utilityKey?: string | undefined): Observable<LookupItemResponse> {
        let url_ = this.baseUrl + "/utility?";
        if (utilityKey === null)
            throw new Error("The parameter 'utilityKey' cannot be null.");
        else if (utilityKey !== undefined)
            url_ += "utilityKey=" + encodeURIComponent("" + utilityKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lookupItem);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupItemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupItemResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<LookupItemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupItemResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupItemResponse>(null as any);
    }

    put(id: number, utilityKey: string, lookupItem: LookupItem): Observable<LookupItemResponse> {
        let url_ = this.baseUrl + "/utility/{id}/{utilityKey}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (utilityKey === undefined || utilityKey === null)
            throw new Error("The parameter 'utilityKey' must be defined.");
        url_ = url_.replace("{utilityKey}", encodeURIComponent("" + utilityKey));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(lookupItem);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LookupItemResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LookupItemResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<LookupItemResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LookupItemResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LookupItemResponse>(null as any);
    }
}

@Injectable()
export class WashUContactsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * search result for attachments
     * @return returns ViewModels.WashUContacts
     */
    get(): Observable<WashUContacts> {
        let url_ = this.baseUrl + "/washucontacts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WashUContacts>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WashUContacts>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WashUContacts> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WashUContacts;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WashUContacts>(null as any);
    }

    /**
     * search result for attachments
     * @return returns ViewModels.WashUContacts
     */
    put(data: WashUContacts): Observable<WashUContacts> {
        let url_ = this.baseUrl + "/washucontacts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WashUContacts>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WashUContacts>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<WashUContacts> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WashUContacts;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WashUContacts>(null as any);
    }
}

@Injectable()
export class UserProfilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(): Observable<UserProfileViewModel[]> {
        let url_ = this.baseUrl + "/userprofiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserProfileViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfileViewModel[]>(null as any);
    }

    put(data: UserProfileViewModel[]): Observable<UserProfileViewModel[]> {
        let url_ = this.baseUrl + "/userprofiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileViewModel[]>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<UserProfileViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfileViewModel[]>(null as any);
    }

    getUsersByPermission(permission?: string | undefined): Observable<UserProfileViewModel[]> {
        let url_ = this.baseUrl + "/userprofiles/getusersbypermission?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfileViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfileViewModel[]>;
        }));
    }

    protected processGetUsersByPermission(response: HttpResponseBase): Observable<UserProfileViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserProfileViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfileViewModel[]>(null as any);
    }

    getCurrentUserRolePermissions(): Observable<RolePermissionsViewModel> {
        let url_ = this.baseUrl + "/userprofiles/getcurrentuserrolepermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RolePermissionsViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RolePermissionsViewModel>;
        }));
    }

    protected processGetCurrentUserRolePermissions(response: HttpResponseBase): Observable<RolePermissionsViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolePermissionsViewModel;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RolePermissionsViewModel>(null as any);
    }

    updateProfileFromToken(data: UserProfileUpdate): Observable<FileResponse> {
        let url_ = this.baseUrl + "/userprofiles/updateprofilefromtoken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfileFromToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfileFromToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateProfileFromToken(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class SubawardsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * Get the next sequence number of subawards for this Fiscal Year
     */
    getSequence(): Observable<string> {
        let url_ = this.baseUrl + "/subawards/nextsequence";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSequence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSequence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processGetSequence(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Get Subrecipient by id
     * @param id subrecipient id
     * @return subaward data model
     */
    get(id: number): Observable<Subaward> {
        let url_ = this.baseUrl + "/subawards/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subaward>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subaward>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Subaward> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subaward;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Subaward>(null as any);
    }

    put(id: number, data: Subaward): Observable<ManageSubawardResponse> {
        let url_ = this.baseUrl + "/subawards/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageSubawardResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageSubawardResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<ManageSubawardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManageSubawardResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManageSubawardResponse>(null as any);
    }

    /**
     * Deletes a subaward by id
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/subawards/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Clones Subrecipient by id
     * @param id subrecipient id
     * @return subaward data model
     */
    clone(id: number): Observable<Subaward> {
        let url_ = this.baseUrl + "/subawards/clone/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Subaward>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Subaward>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<Subaward> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Subaward;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Subaward>(null as any);
    }

    post(data: Subaward): Observable<ManageSubawardResponse> {
        let url_ = this.baseUrl + "/subawards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManageSubawardResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManageSubawardResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ManageSubawardResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ManageSubawardResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManageSubawardResponse>(null as any);
    }

    /**
     * Get a list of users who have claimed subawards / assigned GAs
     */
    getClaimingGAList(): Observable<string[]> {
        let url_ = this.baseUrl + "/subawards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetClaimingGAList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetClaimingGAList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetClaimingGAList(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    populateAttachment(subawardId: number, attachmentId: number): Observable<PopulateAttachmentResult> {
        let url_ = this.baseUrl + "/subawards/{subawardId}/{attachmentId}";
        if (subawardId === undefined || subawardId === null)
            throw new Error("The parameter 'subawardId' must be defined.");
        url_ = url_.replace("{subawardId}", encodeURIComponent("" + subawardId));
        if (attachmentId === undefined || attachmentId === null)
            throw new Error("The parameter 'attachmentId' must be defined.");
        url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPopulateAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPopulateAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PopulateAttachmentResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PopulateAttachmentResult>;
        }));
    }

    protected processPopulateAttachment(response: HttpResponseBase): Observable<PopulateAttachmentResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulateAttachmentResult;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PopulateAttachmentResult>(null as any);
    }

    generateFullAgreementPdf(id: number): Observable<GenerateFullAgreementPdfResponse> {
        let url_ = this.baseUrl + "/subawards/{id}/actions/generate-full-agreement-pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateFullAgreementPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateFullAgreementPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateFullAgreementPdfResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateFullAgreementPdfResponse>;
        }));
    }

    protected processGenerateFullAgreementPdf(response: HttpResponseBase): Observable<GenerateFullAgreementPdfResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GenerateFullAgreementPdfResponse;
            return _observableOf(result202);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenerateFullAgreementPdfResponse>(null as any);
    }

    signAgreement(subawardId: number, contractAttachmentId: number): Observable<PopulateAttachmentResult> {
        let url_ = this.baseUrl + "/subawards/sign/{subawardId}/{contractAttachmentId}";
        if (subawardId === undefined || subawardId === null)
            throw new Error("The parameter 'subawardId' must be defined.");
        url_ = url_.replace("{subawardId}", encodeURIComponent("" + subawardId));
        if (contractAttachmentId === undefined || contractAttachmentId === null)
            throw new Error("The parameter 'contractAttachmentId' must be defined.");
        url_ = url_.replace("{contractAttachmentId}", encodeURIComponent("" + contractAttachmentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSignAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSignAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PopulateAttachmentResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PopulateAttachmentResult>;
        }));
    }

    protected processSignAgreement(response: HttpResponseBase): Observable<PopulateAttachmentResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PopulateAttachmentResult;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PopulateAttachmentResult>(null as any);
    }

    getGrant(id: string): Observable<GrantsResponse> {
        let url_ = this.baseUrl + "/subawards/grant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGrant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GrantsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GrantsResponse>;
        }));
    }

    protected processGetGrant(response: HttpResponseBase): Observable<GrantsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GrantsResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GrantsResponse>(null as any);
    }
}

@Injectable()
export class CchRollupReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | null | undefined, dateThru?: Date | null | undefined, cchStart?: number | null | undefined, cchEnd?: number | null | undefined, fISLegacyDeptNumber?: number | null | undefined): Observable<CchRollupReportResponse> {
        let url_ = this.baseUrl + "/cchrollupreport?";
        if (dateFrom !== undefined && dateFrom !== null)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru !== undefined && dateThru !== null)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        if (cchStart !== undefined && cchStart !== null)
            url_ += "cchStart=" + encodeURIComponent("" + cchStart) + "&";
        if (cchEnd !== undefined && cchEnd !== null)
            url_ += "cchEnd=" + encodeURIComponent("" + cchEnd) + "&";
        if (fISLegacyDeptNumber !== undefined && fISLegacyDeptNumber !== null)
            url_ += "FISLegacyDeptNumber=" + encodeURIComponent("" + fISLegacyDeptNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CchRollupReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CchRollupReportResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CchRollupReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CchRollupReportResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CchRollupReportResponse>(null as any);
    }
}

@Injectable()
export class CollaboratorsExecutedSubsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined, location?: string | null | undefined, sponsor?: string | null | undefined, collaborator?: string | null | undefined): Observable<CollaboratorsExecutedSubsViewModel[]> {
        let url_ = this.baseUrl + "/collaboratorsexecutedsubs?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        if (location !== undefined && location !== null)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (sponsor !== undefined && sponsor !== null)
            url_ += "sponsor=" + encodeURIComponent("" + sponsor) + "&";
        if (collaborator !== undefined && collaborator !== null)
            url_ += "collaborator=" + encodeURIComponent("" + collaborator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CollaboratorsExecutedSubsViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CollaboratorsExecutedSubsViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CollaboratorsExecutedSubsViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollaboratorsExecutedSubsViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CollaboratorsExecutedSubsViewModel[]>(null as any);
    }
}

@Injectable()
export class COWorklistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(wUPILastName?: string | null | undefined, wUPIFirstName?: string | null | undefined, proposalId?: string | null | undefined, awardDept?: string | null | undefined, grantWorkTag?: string | null | undefined, costCenterId?: string | null | undefined, issuingDept?: string | null | undefined, agreementNum?: string | null | undefined, trackingNum?: string | null | undefined, daysSinceSubmission?: string | null | undefined, statuses?: string[] | null | undefined, subrecipient?: string | null | undefined, dAStatus?: boolean | undefined, assignedGA?: string | null | undefined, foreignEntity?: string | null | undefined, subContractType?: string | null | undefined, showRepeatSubmissions?: boolean | null | undefined, limitResults?: boolean | undefined): Observable<COWorklistViewModel[]> {
        let url_ = this.baseUrl + "/coworklist?";
        if (wUPILastName !== undefined && wUPILastName !== null)
            url_ += "WUPILastName=" + encodeURIComponent("" + wUPILastName) + "&";
        if (wUPIFirstName !== undefined && wUPIFirstName !== null)
            url_ += "WUPIFirstName=" + encodeURIComponent("" + wUPIFirstName) + "&";
        if (proposalId !== undefined && proposalId !== null)
            url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
        if (awardDept !== undefined && awardDept !== null)
            url_ += "awardDept=" + encodeURIComponent("" + awardDept) + "&";
        if (grantWorkTag !== undefined && grantWorkTag !== null)
            url_ += "grantWorkTag=" + encodeURIComponent("" + grantWorkTag) + "&";
        if (costCenterId !== undefined && costCenterId !== null)
            url_ += "costCenterId=" + encodeURIComponent("" + costCenterId) + "&";
        if (issuingDept !== undefined && issuingDept !== null)
            url_ += "issuingDept=" + encodeURIComponent("" + issuingDept) + "&";
        if (agreementNum !== undefined && agreementNum !== null)
            url_ += "agreementNum=" + encodeURIComponent("" + agreementNum) + "&";
        if (trackingNum !== undefined && trackingNum !== null)
            url_ += "trackingNum=" + encodeURIComponent("" + trackingNum) + "&";
        if (daysSinceSubmission !== undefined && daysSinceSubmission !== null)
            url_ += "daysSinceSubmission=" + encodeURIComponent("" + daysSinceSubmission) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (subrecipient !== undefined && subrecipient !== null)
            url_ += "subrecipient=" + encodeURIComponent("" + subrecipient) + "&";
        if (dAStatus === null)
            throw new Error("The parameter 'dAStatus' cannot be null.");
        else if (dAStatus !== undefined)
            url_ += "DAStatus=" + encodeURIComponent("" + dAStatus) + "&";
        if (assignedGA !== undefined && assignedGA !== null)
            url_ += "assignedGA=" + encodeURIComponent("" + assignedGA) + "&";
        if (foreignEntity !== undefined && foreignEntity !== null)
            url_ += "foreignEntity=" + encodeURIComponent("" + foreignEntity) + "&";
        if (subContractType !== undefined && subContractType !== null)
            url_ += "subContractType=" + encodeURIComponent("" + subContractType) + "&";
        if (showRepeatSubmissions !== undefined && showRepeatSubmissions !== null)
            url_ += "showRepeatSubmissions=" + encodeURIComponent("" + showRepeatSubmissions) + "&";
        if (limitResults === null)
            throw new Error("The parameter 'limitResults' cannot be null.");
        else if (limitResults !== undefined)
            url_ += "limitResults=" + encodeURIComponent("" + limitResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<COWorklistViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<COWorklistViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<COWorklistViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as COWorklistViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<COWorklistViewModel[]>(null as any);
    }
}

@Injectable()
export class DAWorklistClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(wUPILastName?: string | null | undefined, wUPIFirstName?: string | null | undefined, sponsor?: string | null | undefined, proposalId?: string | null | undefined, awardDept?: string | null | undefined, grantWorkTag?: string | null | undefined, costCenterId?: string | null | undefined, pONumber?: string | null | undefined, status?: string | null | undefined, subrecipient?: string | null | undefined, subPILastName?: string | null | undefined, oSRSStatus?: boolean | undefined, assignedGA?: string | null | undefined, foreignEntity?: string | null | undefined, needAdvancePayment?: string | null | undefined, budgetYear?: number | null | undefined, budgetMonth?: number | null | undefined, limitResults?: boolean | undefined): Observable<DAWorklistViewModel[]> {
        let url_ = this.baseUrl + "/daworklist?";
        if (wUPILastName !== undefined && wUPILastName !== null)
            url_ += "WUPILastName=" + encodeURIComponent("" + wUPILastName) + "&";
        if (wUPIFirstName !== undefined && wUPIFirstName !== null)
            url_ += "WUPIFirstName=" + encodeURIComponent("" + wUPIFirstName) + "&";
        if (sponsor !== undefined && sponsor !== null)
            url_ += "sponsor=" + encodeURIComponent("" + sponsor) + "&";
        if (proposalId !== undefined && proposalId !== null)
            url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
        if (awardDept !== undefined && awardDept !== null)
            url_ += "awardDept=" + encodeURIComponent("" + awardDept) + "&";
        if (grantWorkTag !== undefined && grantWorkTag !== null)
            url_ += "grantWorkTag=" + encodeURIComponent("" + grantWorkTag) + "&";
        if (costCenterId !== undefined && costCenterId !== null)
            url_ += "costCenterId=" + encodeURIComponent("" + costCenterId) + "&";
        if (pONumber !== undefined && pONumber !== null)
            url_ += "pONumber=" + encodeURIComponent("" + pONumber) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (subrecipient !== undefined && subrecipient !== null)
            url_ += "subrecipient=" + encodeURIComponent("" + subrecipient) + "&";
        if (subPILastName !== undefined && subPILastName !== null)
            url_ += "subPILastName=" + encodeURIComponent("" + subPILastName) + "&";
        if (oSRSStatus === null)
            throw new Error("The parameter 'oSRSStatus' cannot be null.");
        else if (oSRSStatus !== undefined)
            url_ += "OSRSStatus=" + encodeURIComponent("" + oSRSStatus) + "&";
        if (assignedGA !== undefined && assignedGA !== null)
            url_ += "assignedGA=" + encodeURIComponent("" + assignedGA) + "&";
        if (foreignEntity !== undefined && foreignEntity !== null)
            url_ += "foreignEntity=" + encodeURIComponent("" + foreignEntity) + "&";
        if (needAdvancePayment !== undefined && needAdvancePayment !== null)
            url_ += "needAdvancePayment=" + encodeURIComponent("" + needAdvancePayment) + "&";
        if (budgetYear !== undefined && budgetYear !== null)
            url_ += "budgetYear=" + encodeURIComponent("" + budgetYear) + "&";
        if (budgetMonth !== undefined && budgetMonth !== null)
            url_ += "budgetMonth=" + encodeURIComponent("" + budgetMonth) + "&";
        if (limitResults === null)
            throw new Error("The parameter 'limitResults' cannot be null.");
        else if (limitResults !== undefined)
            url_ += "limitResults=" + encodeURIComponent("" + limitResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DAWorklistViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DAWorklistViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DAWorklistViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DAWorklistViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DAWorklistViewModel[]>(null as any);
    }
}

@Injectable()
export class FFATAReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    getGrantReport(summaryOnly?: boolean | undefined, month?: number | undefined, year?: number | undefined, fiscalYear?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/ffatareport/grant?";
        if (summaryOnly === null)
            throw new Error("The parameter 'summaryOnly' cannot be null.");
        else if (summaryOnly !== undefined)
            url_ += "summaryOnly=" + encodeURIComponent("" + summaryOnly) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' cannot be null.");
        else if (fiscalYear !== undefined)
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGrantReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGrantReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetGrantReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getContractReport(summaryOnly?: boolean | undefined, month?: number | undefined, year?: number | undefined, fiscalYear?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/ffatareport/contract?";
        if (summaryOnly === null)
            throw new Error("The parameter 'summaryOnly' cannot be null.");
        else if (summaryOnly !== undefined)
            url_ += "summaryOnly=" + encodeURIComponent("" + summaryOnly) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (fiscalYear === null)
            throw new Error("The parameter 'fiscalYear' cannot be null.");
        else if (fiscalYear !== undefined)
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetContractReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

@Injectable()
export class InstitutionAuditReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined, institutionName?: string | null | undefined, dunsNumber?: string | null | undefined, uniqueEntityId?: string | null | undefined, updatedBy?: string | null | undefined): Observable<InstitutionAuditReportResponse> {
        let url_ = this.baseUrl + "/institutionauditreport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        if (institutionName !== undefined && institutionName !== null)
            url_ += "institutionName=" + encodeURIComponent("" + institutionName) + "&";
        if (dunsNumber !== undefined && dunsNumber !== null)
            url_ += "dunsNumber=" + encodeURIComponent("" + dunsNumber) + "&";
        if (uniqueEntityId !== undefined && uniqueEntityId !== null)
            url_ += "uniqueEntityId=" + encodeURIComponent("" + uniqueEntityId) + "&";
        if (updatedBy !== undefined && updatedBy !== null)
            url_ += "updatedBy=" + encodeURIComponent("" + updatedBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InstitutionAuditReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InstitutionAuditReportResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InstitutionAuditReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstitutionAuditReportResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InstitutionAuditReportResponse>(null as any);
    }
}

@Injectable()
export class InstitutionReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined): Observable<NewInstitutionReportResponse> {
        let url_ = this.baseUrl + "/institutionreport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewInstitutionReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewInstitutionReportResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NewInstitutionReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewInstitutionReportResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NewInstitutionReportResponse>(null as any);
    }
}

@Injectable()
export class OsrsReviewReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined, assignedGA?: string | null | undefined): Observable<OsrsReviewReportResponse> {
        let url_ = this.baseUrl + "/osrsreviewreport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        if (assignedGA !== undefined && assignedGA !== null)
            url_ += "assignedGA=" + encodeURIComponent("" + assignedGA) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OsrsReviewReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OsrsReviewReportResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OsrsReviewReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OsrsReviewReportResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OsrsReviewReportResponse>(null as any);
    }
}

@Injectable()
export class OutgoingActivityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    getReport(fyStart?: number | undefined, fyEnd?: number | undefined): Observable<OutgoingActivityReportModel[]> {
        let url_ = this.baseUrl + "/outgoingactivity?";
        if (fyStart === null)
            throw new Error("The parameter 'fyStart' cannot be null.");
        else if (fyStart !== undefined)
            url_ += "fyStart=" + encodeURIComponent("" + fyStart) + "&";
        if (fyEnd === null)
            throw new Error("The parameter 'fyEnd' cannot be null.");
        else if (fyEnd !== undefined)
            url_ += "fyEnd=" + encodeURIComponent("" + fyEnd) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutgoingActivityReportModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutgoingActivityReportModel[]>;
        }));
    }

    protected processGetReport(response: HttpResponseBase): Observable<OutgoingActivityReportModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutgoingActivityReportModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutgoingActivityReportModel[]>(null as any);
    }
}

@Injectable()
export class OutgoingSubsStatusReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined, assignedGA?: string | null | undefined): Observable<OutgoingSubsStatusViewModel[]> {
        let url_ = this.baseUrl + "/outgoingsubsstatusreport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        if (assignedGA !== undefined && assignedGA !== null)
            url_ += "assignedGA=" + encodeURIComponent("" + assignedGA) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OutgoingSubsStatusViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OutgoingSubsStatusViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OutgoingSubsStatusViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OutgoingSubsStatusViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OutgoingSubsStatusViewModel[]>(null as any);
    }
}

@Injectable()
export class ReturnReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined, assignedGA?: string | null | undefined): Observable<ReturnReportViewModel[]> {
        let url_ = this.baseUrl + "/returnreport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        if (assignedGA !== undefined && assignedGA !== null)
            url_ += "assignedGA=" + encodeURIComponent("" + assignedGA) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnReportViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnReportViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReturnReportViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReturnReportViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnReportViewModel[]>(null as any);
    }
}

@Injectable()
export class SentDistFFATAReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined, osrsGA?: string | null | undefined, type?: string | null | undefined): Observable<SentDistFFATAReportViewModel[]> {
        let url_ = this.baseUrl + "/sentdistffatareport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        if (osrsGA !== undefined && osrsGA !== null)
            url_ += "osrsGA=" + encodeURIComponent("" + osrsGA) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SentDistFFATAReportViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SentDistFFATAReportViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SentDistFFATAReportViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SentDistFFATAReportViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SentDistFFATAReportViewModel[]>(null as any);
    }
}

@Injectable()
export class TerminationsPerEoReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    get(dateFrom?: Date | undefined, dateThru?: Date | undefined): Observable<TerminationsPerEOReportViewModel[]> {
        let url_ = this.baseUrl + "/terminationspereoreport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toISOString() : "") + "&";
        if (dateThru === null)
            throw new Error("The parameter 'dateThru' cannot be null.");
        else if (dateThru !== undefined)
            url_ += "dateThru=" + encodeURIComponent(dateThru ? "" + dateThru.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TerminationsPerEOReportViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TerminationsPerEOReportViewModel[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TerminationsPerEOReportViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TerminationsPerEOReportViewModel[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TerminationsPerEOReportViewModel[]>(null as any);
    }
}

@Injectable()
export class ProposalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * Find matching proposal by ID
     * @param id (optional) 
     * @return returns the proposals with the passed proposal id
     */
    getProposal(id?: string | undefined): Observable<ProposalModel> {
        let url_ = this.baseUrl + "/proposal?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProposal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProposal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProposalModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProposalModel>;
        }));
    }

    protected processGetProposal(response: HttpResponseBase): Observable<ProposalModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProposalModel;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProposalModel>(null as any);
    }
}

@Injectable()
export class AdditionalYearsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * Adds a new year
     * @return returns the saved project
     */
    put(id: number): Observable<GetProject> {
        let url_ = this.baseUrl + "/additionalyears/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProject>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProject>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<GetProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProject;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProject>(null as any);
    }
}

@Injectable()
export class ProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * Find matching projects
     * @return returns the project with the passed proposal id
     */
    getAll(proposalId: string): Observable<GetProject[]> {
        let url_ = this.baseUrl + "/projects?";
        if (proposalId === undefined || proposalId === null)
            throw new Error("The parameter 'proposalId' must be defined and cannot be null.");
        else
            url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProject[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProject[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GetProject[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProject[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProject[]>(null as any);
    }

    /**
     * Adds a new project
     * @return returns the saved project
     */
    post(project: PostProjectViewModel): Observable<GetProject> {
        let url_ = this.baseUrl + "/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProject>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProject>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<GetProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProject;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProject>(null as any);
    }

    /**
     * Retrieve project by ID
     * @return returns the project with the passed proposal id
     */
    get(id: number): Observable<GetProject> {
        let url_ = this.baseUrl + "/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProject>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProject>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProject;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProject>(null as any);
    }

    /**
     * Update an existing project
     * @return returns the saved project
     */
    put(id: number, project: PostProjectViewModel): Observable<GetProject> {
        let url_ = this.baseUrl + "/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProject>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProject>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<GetProject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetProject;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProject>(null as any);
    }

    /**
     * Deletes a project by id
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProjectSearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * search result for projects
     * @param proposalId (optional) 
     * @param awardDepartment (optional) 
     * @param grantWorkTag (optional) 
     * @param costCenterId (optional) 
     * @param pONumber (optional) 
     * @param awardNumber (optional) 
     * @param subrecipient (optional) 
     * @param pILastName (optional) 
     * @param pIFirstName (optional) 
     * @param agreementNumber (optional) 
     * @param status (optional) 
     * @param subPILastName (optional) 
     * @param subPIFirstName (optional) 
     * @param sponsor (optional) 
     * @param riskCategory (optional) 
     * @param countryName (optional) 
     * @param foreignEntity (optional) 
     * @param maxResults (optional) 
     * @return List of ProjectSearchResult
     */
    get(proposalId?: string | null | undefined, awardDepartment?: string | null | undefined, grantWorkTag?: string | null | undefined, costCenterId?: string | null | undefined, pONumber?: string | null | undefined, awardNumber?: string | null | undefined, subrecipient?: string | null | undefined, pILastName?: string | null | undefined, pIFirstName?: string | null | undefined, agreementNumber?: string | null | undefined, status?: string | null | undefined, subPILastName?: string | null | undefined, subPIFirstName?: string | null | undefined, sponsor?: string | null | undefined, riskCategory?: string | null | undefined, countryName?: string | null | undefined, foreignEntity?: string | null | undefined, maxResults?: string | null | undefined): Observable<ProjectSearchResult[]> {
        let url_ = this.baseUrl + "/projectsearch?";
        if (proposalId !== undefined && proposalId !== null)
            url_ += "proposalId=" + encodeURIComponent("" + proposalId) + "&";
        if (awardDepartment !== undefined && awardDepartment !== null)
            url_ += "awardDepartment=" + encodeURIComponent("" + awardDepartment) + "&";
        if (grantWorkTag !== undefined && grantWorkTag !== null)
            url_ += "grantWorkTag=" + encodeURIComponent("" + grantWorkTag) + "&";
        if (costCenterId !== undefined && costCenterId !== null)
            url_ += "costCenterId=" + encodeURIComponent("" + costCenterId) + "&";
        if (pONumber !== undefined && pONumber !== null)
            url_ += "pONumber=" + encodeURIComponent("" + pONumber) + "&";
        if (awardNumber !== undefined && awardNumber !== null)
            url_ += "awardNumber=" + encodeURIComponent("" + awardNumber) + "&";
        if (subrecipient !== undefined && subrecipient !== null)
            url_ += "subrecipient=" + encodeURIComponent("" + subrecipient) + "&";
        if (pILastName !== undefined && pILastName !== null)
            url_ += "pILastName=" + encodeURIComponent("" + pILastName) + "&";
        if (pIFirstName !== undefined && pIFirstName !== null)
            url_ += "pIFirstName=" + encodeURIComponent("" + pIFirstName) + "&";
        if (agreementNumber !== undefined && agreementNumber !== null)
            url_ += "agreementNumber=" + encodeURIComponent("" + agreementNumber) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (subPILastName !== undefined && subPILastName !== null)
            url_ += "subPILastName=" + encodeURIComponent("" + subPILastName) + "&";
        if (subPIFirstName !== undefined && subPIFirstName !== null)
            url_ += "subPIFirstName=" + encodeURIComponent("" + subPIFirstName) + "&";
        if (sponsor !== undefined && sponsor !== null)
            url_ += "sponsor=" + encodeURIComponent("" + sponsor) + "&";
        if (riskCategory !== undefined && riskCategory !== null)
            url_ += "riskCategory=" + encodeURIComponent("" + riskCategory) + "&";
        if (countryName !== undefined && countryName !== null)
            url_ += "countryName=" + encodeURIComponent("" + countryName) + "&";
        if (foreignEntity !== undefined && foreignEntity !== null)
            url_ += "foreignEntity=" + encodeURIComponent("" + foreignEntity) + "&";
        if (maxResults !== undefined && maxResults !== null)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectSearchResult[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectSearchResult[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectSearchResult[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectSearchResult[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProjectSearchResult[]>(null as any);
    }
}

@Injectable()
export class InstitutionsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * Creates an institution
     */
    create(data: Institution): Observable<Institution> {
        let url_ = this.baseUrl + "/institutions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Institution>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Institution>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<Institution> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Institution;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Institution>(null as any);
    }

    /**
     * Searches for institutions that match the parameters provided
     * @param institutionId (optional) 
     * @param dunsNumber (optional) 
     * @param institutionName (optional) 
     * @param status (optional) 
     * @param uniqueEntityId (optional) 
     * @param supplierId (optional) 
     * @param riskCategory (optional) 
     * @param countryName (optional) 
     * @param samGov (optional) 
     * @param foreignEntity (optional) 
     * @param deleted (optional) 
     * @param primaryInstitution (optional) 
     * @param exactMatch (optional) determinates if the search is exact or with contains and start with
     * @param limitResults (optional) 
     */
    search(institutionId?: string | null | undefined, dunsNumber?: string | null | undefined, institutionName?: string | null | undefined, status?: string | null | undefined, uniqueEntityId?: string | null | undefined, supplierId?: string | null | undefined, riskCategory?: string | null | undefined, countryName?: string | null | undefined, samGov?: string | null | undefined, foreignEntity?: string | null | undefined, deleted?: string | null | undefined, primaryInstitution?: boolean | undefined, exactMatch?: boolean | undefined, limitResults?: boolean | undefined): Observable<Institution[]> {
        let url_ = this.baseUrl + "/institutions?";
        if (institutionId !== undefined && institutionId !== null)
            url_ += "institutionId=" + encodeURIComponent("" + institutionId) + "&";
        if (dunsNumber !== undefined && dunsNumber !== null)
            url_ += "dunsNumber=" + encodeURIComponent("" + dunsNumber) + "&";
        if (institutionName !== undefined && institutionName !== null)
            url_ += "institutionName=" + encodeURIComponent("" + institutionName) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (uniqueEntityId !== undefined && uniqueEntityId !== null)
            url_ += "uniqueEntityId=" + encodeURIComponent("" + uniqueEntityId) + "&";
        if (supplierId !== undefined && supplierId !== null)
            url_ += "supplierId=" + encodeURIComponent("" + supplierId) + "&";
        if (riskCategory !== undefined && riskCategory !== null)
            url_ += "riskCategory=" + encodeURIComponent("" + riskCategory) + "&";
        if (countryName !== undefined && countryName !== null)
            url_ += "countryName=" + encodeURIComponent("" + countryName) + "&";
        if (samGov !== undefined && samGov !== null)
            url_ += "samGov=" + encodeURIComponent("" + samGov) + "&";
        if (foreignEntity !== undefined && foreignEntity !== null)
            url_ += "foreignEntity=" + encodeURIComponent("" + foreignEntity) + "&";
        if (deleted !== undefined && deleted !== null)
            url_ += "deleted=" + encodeURIComponent("" + deleted) + "&";
        if (primaryInstitution === null)
            throw new Error("The parameter 'primaryInstitution' cannot be null.");
        else if (primaryInstitution !== undefined)
            url_ += "primaryInstitution=" + encodeURIComponent("" + primaryInstitution) + "&";
        if (exactMatch === null)
            throw new Error("The parameter 'exactMatch' cannot be null.");
        else if (exactMatch !== undefined)
            url_ += "exactMatch=" + encodeURIComponent("" + exactMatch) + "&";
        if (limitResults === null)
            throw new Error("The parameter 'limitResults' cannot be null.");
        else if (limitResults !== undefined)
            url_ += "limitResults=" + encodeURIComponent("" + limitResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Institution[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Institution[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<Institution[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Institution[];
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Institution[]>(null as any);
    }

    /**
     * Updates an institution
     */
    update(id: number, data: Institution): Observable<Institution> {
        let url_ = this.baseUrl + "/institutions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Institution>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Institution>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Institution> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Institution;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Institution>(null as any);
    }

    /**
     * Get an institution by Id
     * @param id id of institution
     * @return Institution data model.
     */
    get(id: number): Observable<Institution> {
        let url_ = this.baseUrl + "/institutions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Institution>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Institution>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Institution> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Institution;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Institution>(null as any);
    }

    /**
     * Deletes an institution by id
     */
    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/institutions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class FilesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * Adds a new file
     * @param contentType (optional) 
     * @param contentDisposition (optional) 
     * @param headers (optional) 
     * @param length (optional) 
     * @param name (optional) 
     * @param fileName (optional) 
     * @return returns the identifier for the file
     */
    post(contentType?: string | null | undefined, contentDisposition?: string | null | undefined, headers?: any[] | null | undefined, length?: number | undefined, name?: string | null | undefined, fileName?: string | null | undefined): Observable<File> {
        let url_ = this.baseUrl + "/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<File>;
                }
            } else
                return _observableThrow(response_) as any as Observable<File>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<File> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as File;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<File>(null as any);
    }

    /**
     * Gets the contents of a file
     * @return The file contents
     */
    get(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * Deletes the file from storage and the database
     */
    delete(id: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/files/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * Gets the size of a file in bytes, without downloading its contents
     */
    getSize(id: string): Observable<FileSize> {
        let url_ = this.baseUrl + "/files/{id}/size";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileSize>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileSize>;
        }));
    }

    protected processGetSize(response: HttpResponseBase): Observable<FileSize> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileSize;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileSize>(null as any);
    }

    /**
     * Gets the contents of a file
     * @return The file contents
     */
    get2(id: string, name: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/files/{id}/{name}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    /**
     * Adds a new file
     * @return returns the identifier for the file
     */
    clone(id: string): Observable<File> {
        let url_ = this.baseUrl + "/files/{id}/actions/clone";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<File>;
                }
            } else
                return _observableThrow(response_) as any as Observable<File>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<File> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as File;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<File>(null as any);
    }
}

@Injectable()
export class EmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    getEmployees(firstName?: string | null | undefined, lastName?: string | null | undefined, employeeId?: string | null | undefined): Observable<GetEmployeesResponse[]> {
        let url_ = this.baseUrl + "/employee?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmployees(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmployees(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeesResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeesResponse[]>;
        }));
    }

    protected processGetEmployees(response: HttpResponseBase): Observable<GetEmployeesResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetEmployeesResponse[];
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeesResponse[]>(null as any);
    }
}

@Injectable()
export class EmailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    /**
     * Gets the configured maximum email size (in MB) allowed for emails with attachments
     */
    getSizeLimit(): Observable<EmailSizeLimitResponse> {
        let url_ = this.baseUrl + "/emails/sizelimit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSizeLimit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSizeLimit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EmailSizeLimitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EmailSizeLimitResponse>;
        }));
    }

    protected processGetSizeLimit(response: HttpResponseBase): Observable<EmailSizeLimitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmailSizeLimitResponse;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationError[];
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EmailSizeLimitResponse>(null as any);
    }

    /**
     * Sends Financial Risk Emal to SPA
     */
    post(emailModel: FinancialRiskEmail): Observable<void> {
        let url_ = this.baseUrl + "/emails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Sends Request for Collaboration Information to Subrecipient
     * @param dataAttachment (optional) 
     * @param fileAttachmentId (optional) 
     * @param fromEmail (optional) 
     * @param toEmail (optional) 
     * @param subrecipient (optional) 
     * @param subPrincipalInvestigatorFirstName (optional) 
     * @param subPrincipalInvestigatorLastName (optional) 
     * @param subDepartmentAdminFirstName (optional) 
     * @param subDepartmentAdminLastName (optional) 
     * @param wUDeptAdminFirstName (optional) 
     * @param wUDeptAdminLastName (optional) 
     * @param wUDeptAdminPhone (optional) 
     * @param wUDeptAdminEmail (optional) 
     * @param wUDeptAdminFax (optional) 
     * @param washUPrincipalInvestigatorFirstName (optional) 
     * @param washUPrincipalInvestigatorLastName (optional) 
     * @param fileAttachmentName (optional) 
     */
    postCollaboratorEmail(dataAttachment?: FileParameter | null | undefined, fileAttachmentId?: string | null | undefined, fromEmail?: string | null | undefined, toEmail?: string | null | undefined, subrecipient?: string | null | undefined, subPrincipalInvestigatorFirstName?: string | null | undefined, subPrincipalInvestigatorLastName?: string | null | undefined, subDepartmentAdminFirstName?: string | null | undefined, subDepartmentAdminLastName?: string | null | undefined, wUDeptAdminFirstName?: string | null | undefined, wUDeptAdminLastName?: string | null | undefined, wUDeptAdminPhone?: string | null | undefined, wUDeptAdminEmail?: string | null | undefined, wUDeptAdminFax?: string | null | undefined, washUPrincipalInvestigatorFirstName?: string | null | undefined, washUPrincipalInvestigatorLastName?: string | null | undefined, fileAttachmentName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emails/collaboratorinfoemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dataAttachment !== null && dataAttachment !== undefined)
            content_.append("DataAttachment", dataAttachment.data, dataAttachment.fileName ? dataAttachment.fileName : "DataAttachment");
        if (fileAttachmentId !== null && fileAttachmentId !== undefined)
            content_.append("FileAttachmentId", fileAttachmentId.toString());
        if (fromEmail !== null && fromEmail !== undefined)
            content_.append("FromEmail", fromEmail.toString());
        if (toEmail !== null && toEmail !== undefined)
            content_.append("ToEmail", toEmail.toString());
        if (subrecipient !== null && subrecipient !== undefined)
            content_.append("Subrecipient", subrecipient.toString());
        if (subPrincipalInvestigatorFirstName !== null && subPrincipalInvestigatorFirstName !== undefined)
            content_.append("SubPrincipalInvestigatorFirstName", subPrincipalInvestigatorFirstName.toString());
        if (subPrincipalInvestigatorLastName !== null && subPrincipalInvestigatorLastName !== undefined)
            content_.append("SubPrincipalInvestigatorLastName", subPrincipalInvestigatorLastName.toString());
        if (subDepartmentAdminFirstName !== null && subDepartmentAdminFirstName !== undefined)
            content_.append("SubDepartmentAdminFirstName", subDepartmentAdminFirstName.toString());
        if (subDepartmentAdminLastName !== null && subDepartmentAdminLastName !== undefined)
            content_.append("SubDepartmentAdminLastName", subDepartmentAdminLastName.toString());
        if (wUDeptAdminFirstName !== null && wUDeptAdminFirstName !== undefined)
            content_.append("WUDeptAdminFirstName", wUDeptAdminFirstName.toString());
        if (wUDeptAdminLastName !== null && wUDeptAdminLastName !== undefined)
            content_.append("WUDeptAdminLastName", wUDeptAdminLastName.toString());
        if (wUDeptAdminPhone !== null && wUDeptAdminPhone !== undefined)
            content_.append("WUDeptAdminPhone", wUDeptAdminPhone.toString());
        if (wUDeptAdminEmail !== null && wUDeptAdminEmail !== undefined)
            content_.append("WUDeptAdminEmail", wUDeptAdminEmail.toString());
        if (wUDeptAdminFax !== null && wUDeptAdminFax !== undefined)
            content_.append("WUDeptAdminFax", wUDeptAdminFax.toString());
        if (washUPrincipalInvestigatorFirstName !== null && washUPrincipalInvestigatorFirstName !== undefined)
            content_.append("WashUPrincipalInvestigatorFirstName", washUPrincipalInvestigatorFirstName.toString());
        if (washUPrincipalInvestigatorLastName !== null && washUPrincipalInvestigatorLastName !== undefined)
            content_.append("WashUPrincipalInvestigatorLastName", washUPrincipalInvestigatorLastName.toString());
        if (fileAttachmentName !== null && fileAttachmentName !== undefined)
            content_.append("FileAttachmentName", fileAttachmentName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCollaboratorEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCollaboratorEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCollaboratorEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    postApproveFEAInternalDistributionEmail(fileAttachmentId?: string | null | undefined, fileAttachmentName?: string | null | undefined, fromEmail?: string | undefined, toEmail?: string | undefined, washUPrincipalInvestigatorFirstName?: string | null | undefined, washUPrincipalInvestigatorLastName?: string | null | undefined, washUPrincipalInvestigatorEmail?: string | null | undefined, awardNumber?: string | null | undefined, agreementNumber?: string | null | undefined, subPrincipalInvestigatorFirstName?: string | null | undefined, subPrincipalInvestigatorLastName?: string | null | undefined, institutionId?: number | undefined, institutionName?: string | null | undefined, proposalId?: string | undefined, grantWorktag?: string | null | undefined, awardYear?: number | null | undefined, costCenterNumber?: string | null | undefined, costCenterName?: string | null | undefined, budget?: string | null | undefined, amendmentNumber?: number | null | undefined, subawardId?: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emails/feainternaldistributionemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileAttachmentId !== null && fileAttachmentId !== undefined)
            content_.append("FileAttachmentId", fileAttachmentId.toString());
        if (fileAttachmentName !== null && fileAttachmentName !== undefined)
            content_.append("FileAttachmentName", fileAttachmentName.toString());
        if (fromEmail === null || fromEmail === undefined)
            throw new Error("The parameter 'fromEmail' cannot be null.");
        else
            content_.append("FromEmail", fromEmail.toString());
        if (toEmail === null || toEmail === undefined)
            throw new Error("The parameter 'toEmail' cannot be null.");
        else
            content_.append("ToEmail", toEmail.toString());
        if (washUPrincipalInvestigatorFirstName !== null && washUPrincipalInvestigatorFirstName !== undefined)
            content_.append("WashUPrincipalInvestigatorFirstName", washUPrincipalInvestigatorFirstName.toString());
        if (washUPrincipalInvestigatorLastName !== null && washUPrincipalInvestigatorLastName !== undefined)
            content_.append("WashUPrincipalInvestigatorLastName", washUPrincipalInvestigatorLastName.toString());
        if (washUPrincipalInvestigatorEmail !== null && washUPrincipalInvestigatorEmail !== undefined)
            content_.append("WashUPrincipalInvestigatorEmail", washUPrincipalInvestigatorEmail.toString());
        if (awardNumber !== null && awardNumber !== undefined)
            content_.append("AwardNumber", awardNumber.toString());
        if (agreementNumber !== null && agreementNumber !== undefined)
            content_.append("AgreementNumber", agreementNumber.toString());
        if (subPrincipalInvestigatorFirstName !== null && subPrincipalInvestigatorFirstName !== undefined)
            content_.append("SubPrincipalInvestigatorFirstName", subPrincipalInvestigatorFirstName.toString());
        if (subPrincipalInvestigatorLastName !== null && subPrincipalInvestigatorLastName !== undefined)
            content_.append("SubPrincipalInvestigatorLastName", subPrincipalInvestigatorLastName.toString());
        if (institutionId === null || institutionId === undefined)
            throw new Error("The parameter 'institutionId' cannot be null.");
        else
            content_.append("InstitutionId", institutionId.toString());
        if (institutionName !== null && institutionName !== undefined)
            content_.append("InstitutionName", institutionName.toString());
        if (proposalId === null || proposalId === undefined)
            throw new Error("The parameter 'proposalId' cannot be null.");
        else
            content_.append("ProposalId", proposalId.toString());
        if (grantWorktag !== null && grantWorktag !== undefined)
            content_.append("GrantWorktag", grantWorktag.toString());
        if (awardYear !== null && awardYear !== undefined)
            content_.append("AwardYear", awardYear.toString());
        if (costCenterNumber !== null && costCenterNumber !== undefined)
            content_.append("CostCenterNumber", costCenterNumber.toString());
        if (costCenterName !== null && costCenterName !== undefined)
            content_.append("CostCenterName", costCenterName.toString());
        if (budget !== null && budget !== undefined)
            content_.append("Budget", budget.toString());
        if (amendmentNumber !== null && amendmentNumber !== undefined)
            content_.append("AmendmentNumber", amendmentNumber.toString());
        if (subawardId === null || subawardId === undefined)
            throw new Error("The parameter 'subawardId' cannot be null.");
        else
            content_.append("SubawardId", subawardId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostApproveFEAInternalDistributionEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostApproveFEAInternalDistributionEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostApproveFEAInternalDistributionEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    postSubmitToOsrsEmail(fromEmail?: string | null | undefined, toEmail?: string | null | undefined, agreementNumber?: string | null | undefined, washUPrincipalInvestigatorFirstName?: string | null | undefined, washUPrincipalInvestigatorLastName?: string | null | undefined, proposalId?: string | null | undefined, issuingFund?: string | null | undefined, institutionId?: number | null | undefined, institutionName?: string | null | undefined, subPrincipalInvestigatorFirstName?: string | null | undefined, subPrincipalInvestigatorLastName?: string | null | undefined, awardYear?: number | null | undefined, issuingDepartment?: string | null | undefined, budget?: string | null | undefined, amendmentNumber?: number | null | undefined, subawardId?: number | null | undefined, awardNumber?: string | null | undefined, sponsorName?: string | null | undefined, indirectCost?: string | null | undefined, directCost?: string | null | undefined, fundingAmount?: string | null | undefined, budgetFromDate?: string | null | undefined, budgetThruDate?: string | null | undefined, pONumber?: string | null | undefined, trackingNumber?: string | null | undefined, cumulative?: string | null | undefined, ffataReportable?: string | null | undefined, wUDeptAdminFirstName?: string | null | undefined, wUDeptAdminLastName?: string | null | undefined, wUDeptAdminPhone?: string | null | undefined, wUDeptAdminEmail?: string | null | undefined, estimatedTotalFunding?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emails/submittoosrsemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fromEmail !== null && fromEmail !== undefined)
            content_.append("FromEmail", fromEmail.toString());
        if (toEmail !== null && toEmail !== undefined)
            content_.append("ToEmail", toEmail.toString());
        if (agreementNumber !== null && agreementNumber !== undefined)
            content_.append("AgreementNumber", agreementNumber.toString());
        if (washUPrincipalInvestigatorFirstName !== null && washUPrincipalInvestigatorFirstName !== undefined)
            content_.append("WashUPrincipalInvestigatorFirstName", washUPrincipalInvestigatorFirstName.toString());
        if (washUPrincipalInvestigatorLastName !== null && washUPrincipalInvestigatorLastName !== undefined)
            content_.append("WashUPrincipalInvestigatorLastName", washUPrincipalInvestigatorLastName.toString());
        if (proposalId !== null && proposalId !== undefined)
            content_.append("ProposalId", proposalId.toString());
        if (issuingFund !== null && issuingFund !== undefined)
            content_.append("IssuingFund", issuingFund.toString());
        if (institutionId !== null && institutionId !== undefined)
            content_.append("InstitutionId", institutionId.toString());
        if (institutionName !== null && institutionName !== undefined)
            content_.append("InstitutionName", institutionName.toString());
        if (subPrincipalInvestigatorFirstName !== null && subPrincipalInvestigatorFirstName !== undefined)
            content_.append("SubPrincipalInvestigatorFirstName", subPrincipalInvestigatorFirstName.toString());
        if (subPrincipalInvestigatorLastName !== null && subPrincipalInvestigatorLastName !== undefined)
            content_.append("SubPrincipalInvestigatorLastName", subPrincipalInvestigatorLastName.toString());
        if (awardYear !== null && awardYear !== undefined)
            content_.append("AwardYear", awardYear.toString());
        if (issuingDepartment !== null && issuingDepartment !== undefined)
            content_.append("IssuingDepartment", issuingDepartment.toString());
        if (budget !== null && budget !== undefined)
            content_.append("Budget", budget.toString());
        if (amendmentNumber !== null && amendmentNumber !== undefined)
            content_.append("AmendmentNumber", amendmentNumber.toString());
        if (subawardId !== null && subawardId !== undefined)
            content_.append("SubawardId", subawardId.toString());
        if (awardNumber !== null && awardNumber !== undefined)
            content_.append("AwardNumber", awardNumber.toString());
        if (sponsorName !== null && sponsorName !== undefined)
            content_.append("SponsorName", sponsorName.toString());
        if (indirectCost !== null && indirectCost !== undefined)
            content_.append("IndirectCost", indirectCost.toString());
        if (directCost !== null && directCost !== undefined)
            content_.append("DirectCost", directCost.toString());
        if (fundingAmount !== null && fundingAmount !== undefined)
            content_.append("FundingAmount", fundingAmount.toString());
        if (budgetFromDate !== null && budgetFromDate !== undefined)
            content_.append("BudgetFromDate", budgetFromDate.toString());
        if (budgetThruDate !== null && budgetThruDate !== undefined)
            content_.append("BudgetThruDate", budgetThruDate.toString());
        if (pONumber !== null && pONumber !== undefined)
            content_.append("PONumber", pONumber.toString());
        if (trackingNumber !== null && trackingNumber !== undefined)
            content_.append("TrackingNumber", trackingNumber.toString());
        if (cumulative !== null && cumulative !== undefined)
            content_.append("Cumulative", cumulative.toString());
        if (ffataReportable !== null && ffataReportable !== undefined)
            content_.append("FfataReportable", ffataReportable.toString());
        if (wUDeptAdminFirstName !== null && wUDeptAdminFirstName !== undefined)
            content_.append("WUDeptAdminFirstName", wUDeptAdminFirstName.toString());
        if (wUDeptAdminLastName !== null && wUDeptAdminLastName !== undefined)
            content_.append("WUDeptAdminLastName", wUDeptAdminLastName.toString());
        if (wUDeptAdminPhone !== null && wUDeptAdminPhone !== undefined)
            content_.append("WUDeptAdminPhone", wUDeptAdminPhone.toString());
        if (wUDeptAdminEmail !== null && wUDeptAdminEmail !== undefined)
            content_.append("WUDeptAdminEmail", wUDeptAdminEmail.toString());
        if (estimatedTotalFunding !== null && estimatedTotalFunding !== undefined)
            content_.append("EstimatedTotalFunding", estimatedTotalFunding.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSubmitToOsrsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSubmitToOsrsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostSubmitToOsrsEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Sends email to subrecipient for new subaward with signature required
     * @param agreementNumber (optional) 
     * @param subPrincipalInvestigatorFirstName (optional) 
     * @param subPrincipalInvestigatorLastName (optional) 
     * @param subPrincipalInvestigatorEmail (optional) 
     * @param wUPrincipalInvestigatorFirstName (optional) 
     * @param wUPrincipalInvestigatorLastName (optional) 
     * @param wUPrincipalInvestigatorEmail (optional) 
     * @param wUDeptAdminEmail (optional) 
     * @param subAdminPOCEmail (optional) 
     * @param centralAdminEmail (optional) 
     * @param fileAttachmentId (optional) 
     * @param fileAttachmentName (optional) 
     */
    postSubrecipientSignatureEmail(agreementNumber?: string | null | undefined, subPrincipalInvestigatorFirstName?: string | null | undefined, subPrincipalInvestigatorLastName?: string | null | undefined, subPrincipalInvestigatorEmail?: string | null | undefined, wUPrincipalInvestigatorFirstName?: string | null | undefined, wUPrincipalInvestigatorLastName?: string | null | undefined, wUPrincipalInvestigatorEmail?: string | null | undefined, wUDeptAdminEmail?: string | null | undefined, subAdminPOCEmail?: string | null | undefined, centralAdminEmail?: string | null | undefined, fileAttachmentId?: string | null | undefined, fileAttachmentName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emails/subrecipientsignatureemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (agreementNumber !== null && agreementNumber !== undefined)
            content_.append("AgreementNumber", agreementNumber.toString());
        if (subPrincipalInvestigatorFirstName !== null && subPrincipalInvestigatorFirstName !== undefined)
            content_.append("SubPrincipalInvestigatorFirstName", subPrincipalInvestigatorFirstName.toString());
        if (subPrincipalInvestigatorLastName !== null && subPrincipalInvestigatorLastName !== undefined)
            content_.append("SubPrincipalInvestigatorLastName", subPrincipalInvestigatorLastName.toString());
        if (subPrincipalInvestigatorEmail !== null && subPrincipalInvestigatorEmail !== undefined)
            content_.append("SubPrincipalInvestigatorEmail", subPrincipalInvestigatorEmail.toString());
        if (wUPrincipalInvestigatorFirstName !== null && wUPrincipalInvestigatorFirstName !== undefined)
            content_.append("WUPrincipalInvestigatorFirstName", wUPrincipalInvestigatorFirstName.toString());
        if (wUPrincipalInvestigatorLastName !== null && wUPrincipalInvestigatorLastName !== undefined)
            content_.append("WUPrincipalInvestigatorLastName", wUPrincipalInvestigatorLastName.toString());
        if (wUPrincipalInvestigatorEmail !== null && wUPrincipalInvestigatorEmail !== undefined)
            content_.append("WUPrincipalInvestigatorEmail", wUPrincipalInvestigatorEmail.toString());
        if (wUDeptAdminEmail !== null && wUDeptAdminEmail !== undefined)
            content_.append("WUDeptAdminEmail", wUDeptAdminEmail.toString());
        if (subAdminPOCEmail !== null && subAdminPOCEmail !== undefined)
            content_.append("SubAdminPOCEmail", subAdminPOCEmail.toString());
        if (centralAdminEmail !== null && centralAdminEmail !== undefined)
            content_.append("CentralAdminEmail", centralAdminEmail.toString());
        if (fileAttachmentId !== null && fileAttachmentId !== undefined)
            content_.append("FileAttachmentId", fileAttachmentId.toString());
        if (fileAttachmentName !== null && fileAttachmentName !== undefined)
            content_.append("FileAttachmentName", fileAttachmentName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSubrecipientSignatureEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSubrecipientSignatureEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostSubrecipientSignatureEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Sends an email to subrecipient notifying them of the purchase order(PO) number.
     * @param agreementNumber (optional) 
     * @param pONumber (optional) 
     * @param supplierContractId (optional) 
     * @param subawardId (optional) 
     * @param sponsorName (optional) 
     * @param subPrincipalInvestigatorFirstName (optional) 
     * @param subPrincipalInvestigatorLastName (optional) 
     * @param subPrincipalInvestigatorEmail (optional) 
     * @param subDeptAdminEmail (optional) 
     * @param subFinancialPOCEmail (optional) 
     * @param centralAdminEmail (optional) 
     * @param fileAttachmentId (optional) 
     * @param fileAttachmentName (optional) 
     */
    postPurchaseOrderNotificationEmail(agreementNumber?: string | null | undefined, pONumber?: string | null | undefined, supplierContractId?: string | null | undefined, subawardId?: number | undefined, sponsorName?: string | null | undefined, subPrincipalInvestigatorFirstName?: string | null | undefined, subPrincipalInvestigatorLastName?: string | null | undefined, subPrincipalInvestigatorEmail?: string | null | undefined, subDeptAdminEmail?: string | null | undefined, subFinancialPOCEmail?: string | null | undefined, centralAdminEmail?: string | null | undefined, fileAttachmentId?: string | null | undefined, fileAttachmentName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emails/ponotificationemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (agreementNumber !== null && agreementNumber !== undefined)
            content_.append("AgreementNumber", agreementNumber.toString());
        if (pONumber !== null && pONumber !== undefined)
            content_.append("PONumber", pONumber.toString());
        if (supplierContractId !== null && supplierContractId !== undefined)
            content_.append("SupplierContractId", supplierContractId.toString());
        if (subawardId === null || subawardId === undefined)
            throw new Error("The parameter 'subawardId' cannot be null.");
        else
            content_.append("SubawardId", subawardId.toString());
        if (sponsorName !== null && sponsorName !== undefined)
            content_.append("SponsorName", sponsorName.toString());
        if (subPrincipalInvestigatorFirstName !== null && subPrincipalInvestigatorFirstName !== undefined)
            content_.append("SubPrincipalInvestigatorFirstName", subPrincipalInvestigatorFirstName.toString());
        if (subPrincipalInvestigatorLastName !== null && subPrincipalInvestigatorLastName !== undefined)
            content_.append("SubPrincipalInvestigatorLastName", subPrincipalInvestigatorLastName.toString());
        if (subPrincipalInvestigatorEmail !== null && subPrincipalInvestigatorEmail !== undefined)
            content_.append("SubPrincipalInvestigatorEmail", subPrincipalInvestigatorEmail.toString());
        if (subDeptAdminEmail !== null && subDeptAdminEmail !== undefined)
            content_.append("SubDeptAdminEmail", subDeptAdminEmail.toString());
        if (subFinancialPOCEmail !== null && subFinancialPOCEmail !== undefined)
            content_.append("SubFinancialPOCEmail", subFinancialPOCEmail.toString());
        if (centralAdminEmail !== null && centralAdminEmail !== undefined)
            content_.append("CentralAdminEmail", centralAdminEmail.toString());
        if (fileAttachmentId !== null && fileAttachmentId !== undefined)
            content_.append("FileAttachmentId", fileAttachmentId.toString());
        if (fileAttachmentName !== null && fileAttachmentName !== undefined)
            content_.append("FileAttachmentName", fileAttachmentName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPurchaseOrderNotificationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPurchaseOrderNotificationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostPurchaseOrderNotificationEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    fCOIEmail(emailModel: FCOIEmailRequest): Observable<void> {
        let url_ = this.baseUrl + "/emails/fcoiemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFCOIEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFCOIEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFCOIEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    postSubUnilatModEmail(fromEmail?: string | null | undefined, toEmail?: string | null | undefined, additionalToEmail?: string | null | undefined, agreementNumber?: string | null | undefined, amendment?: string | null | undefined, awardNumber?: string | null | undefined, subrecipient?: string | null | undefined, subPrincipalInvestigatorFullName?: string | null | undefined, washUPrincipalInvestigatorFullName?: string | null | undefined, washUPrincipalInvestigatorEmail?: string | null | undefined, washUDepartmentAdminEmail?: string | null | undefined, centralAdminEmail?: string | null | undefined, fileAttachmentId?: string | null | undefined, fileAttachmentName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emails/subunilatmodemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fromEmail !== null && fromEmail !== undefined)
            content_.append("FromEmail", fromEmail.toString());
        if (toEmail !== null && toEmail !== undefined)
            content_.append("ToEmail", toEmail.toString());
        if (additionalToEmail !== null && additionalToEmail !== undefined)
            content_.append("AdditionalToEmail", additionalToEmail.toString());
        if (agreementNumber !== null && agreementNumber !== undefined)
            content_.append("AgreementNumber", agreementNumber.toString());
        if (amendment !== null && amendment !== undefined)
            content_.append("Amendment", amendment.toString());
        if (awardNumber !== null && awardNumber !== undefined)
            content_.append("AwardNumber", awardNumber.toString());
        if (subrecipient !== null && subrecipient !== undefined)
            content_.append("Subrecipient", subrecipient.toString());
        if (subPrincipalInvestigatorFullName !== null && subPrincipalInvestigatorFullName !== undefined)
            content_.append("SubPrincipalInvestigatorFullName", subPrincipalInvestigatorFullName.toString());
        if (washUPrincipalInvestigatorFullName !== null && washUPrincipalInvestigatorFullName !== undefined)
            content_.append("WashUPrincipalInvestigatorFullName", washUPrincipalInvestigatorFullName.toString());
        if (washUPrincipalInvestigatorEmail !== null && washUPrincipalInvestigatorEmail !== undefined)
            content_.append("WashUPrincipalInvestigatorEmail", washUPrincipalInvestigatorEmail.toString());
        if (washUDepartmentAdminEmail !== null && washUDepartmentAdminEmail !== undefined)
            content_.append("WashUDepartmentAdminEmail", washUDepartmentAdminEmail.toString());
        if (centralAdminEmail !== null && centralAdminEmail !== undefined)
            content_.append("CentralAdminEmail", centralAdminEmail.toString());
        if (fileAttachmentId !== null && fileAttachmentId !== undefined)
            content_.append("FileAttachmentId", fileAttachmentId.toString());
        if (fileAttachmentName !== null && fileAttachmentName !== undefined)
            content_.append("FileAttachmentName", fileAttachmentName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSubUnilatModEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSubUnilatModEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostSubUnilatModEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Sends email to subreceipient with bilateral modification (counter-signature required)
     * @param fromEmail (optional) 
     * @param toEmail (optional) 
     * @param agreementNumber (optional) 
     * @param amendment (optional) 
     * @param subrecipient (optional) 
     * @param subPrincipalInvestigatorFullName (optional) 
     * @param washUPrincipalInvestigatorFullName (optional) 
     * @param washUPrincipalInvestigatorEmail (optional) 
     * @param washUDepartmentAdminEmail (optional) 
     * @param centralAdminEmail (optional) 
     * @param fileAttachmentId (optional) 
     * @param fileAttachmentName (optional) 
     */
    postSubBilatModEmail(fromEmail?: string | null | undefined, toEmail?: string | null | undefined, agreementNumber?: string | null | undefined, amendment?: string | null | undefined, subrecipient?: string | null | undefined, subPrincipalInvestigatorFullName?: string | null | undefined, washUPrincipalInvestigatorFullName?: string | null | undefined, washUPrincipalInvestigatorEmail?: string | null | undefined, washUDepartmentAdminEmail?: string | null | undefined, centralAdminEmail?: string | null | undefined, fileAttachmentId?: string | null | undefined, fileAttachmentName?: string | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/emails/subbilatmodemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fromEmail !== null && fromEmail !== undefined)
            content_.append("FromEmail", fromEmail.toString());
        if (toEmail !== null && toEmail !== undefined)
            content_.append("ToEmail", toEmail.toString());
        if (agreementNumber !== null && agreementNumber !== undefined)
            content_.append("AgreementNumber", agreementNumber.toString());
        if (amendment !== null && amendment !== undefined)
            content_.append("Amendment", amendment.toString());
        if (subrecipient !== null && subrecipient !== undefined)
            content_.append("Subrecipient", subrecipient.toString());
        if (subPrincipalInvestigatorFullName !== null && subPrincipalInvestigatorFullName !== undefined)
            content_.append("SubPrincipalInvestigatorFullName", subPrincipalInvestigatorFullName.toString());
        if (washUPrincipalInvestigatorFullName !== null && washUPrincipalInvestigatorFullName !== undefined)
            content_.append("WashUPrincipalInvestigatorFullName", washUPrincipalInvestigatorFullName.toString());
        if (washUPrincipalInvestigatorEmail !== null && washUPrincipalInvestigatorEmail !== undefined)
            content_.append("WashUPrincipalInvestigatorEmail", washUPrincipalInvestigatorEmail.toString());
        if (washUDepartmentAdminEmail !== null && washUDepartmentAdminEmail !== undefined)
            content_.append("WashUDepartmentAdminEmail", washUDepartmentAdminEmail.toString());
        if (centralAdminEmail !== null && centralAdminEmail !== undefined)
            content_.append("CentralAdminEmail", centralAdminEmail.toString());
        if (fileAttachmentId !== null && fileAttachmentId !== undefined)
            content_.append("FileAttachmentId", fileAttachmentId.toString());
        if (fileAttachmentName !== null && fileAttachmentName !== undefined)
            content_.append("FileAttachmentName", fileAttachmentName.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSubBilatModEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSubBilatModEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostSubBilatModEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 413) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result413: any = null;
            result413 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result413);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Sends email to DA for returned subaward
     */
    postReturnedToDAEmail(emailModel: ReturnedToDAEmail): Observable<void> {
        let url_ = this.baseUrl + "/emails/returnedtodaemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostReturnedToDAEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostReturnedToDAEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostReturnedToDAEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Sends email to GA for subaward not approved
     */
    postNotApprovedToGaEmail(emailModel: NotApprovedToGAEmail): Observable<void> {
        let url_ = this.baseUrl + "/emails/notapprovedtogaemail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emailModel);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostNotApprovedToGaEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostNotApprovedToGaEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostNotApprovedToGaEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AttachmentsExportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    post(): Observable<void> {
        let url_ = this.baseUrl + "/attachmentsexport";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AttachmentsImportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000/api";
    }

    post(archive?: FileParameter | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/attachmentsimport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (archive !== null && archive !== undefined)
            content_.append("archive", archive.data, archive.fileName ? archive.fileName : "archive");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 202) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("\nor\n", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiError;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ValidationError {
    propertyName?: string | undefined;
    error?: string | undefined;
}

export interface ApiError {
    error?: string | undefined;
    stackTrace?: string | undefined;
    totalSizeMb?: number | undefined;
    sizeLimitMb?: number | undefined;
    emailType?: string | undefined;
    attachmentBytes?: number | undefined;
    otherContentBytes?: number | undefined;
    totalRequestBytes?: number | undefined;
}

export interface Announcement {
    id?: number;
    date?: Date;
    announcementText?: string;
    announcementLink?: string | undefined;
    orderNumber?: number;
    status?: string;
}

export interface PostAttachmentViewModel {
    attachmentFileName?: string | undefined;
    attachmentFileId?: string | undefined;
    attachmentFileModified?: Date;
    sponsor?: string | undefined;
    attachmentNum?: string | undefined;
    description?: string | undefined;
    unilateral?: string | undefined;
    fdp?: boolean | undefined;
    fed?: boolean | undefined;
    archive?: boolean | undefined;
    created?: Date;
    modified?: Date;
    bookmarks?: Bookmark[] | undefined;
}

export interface Attachment extends PostAttachmentViewModel {
    id?: number | undefined;
}

export interface Bookmark {
    id?: number;
    attachmentId?: number;
    name?: string | undefined;
    tableName?: string | undefined;
    fieldName?: string | undefined;
    contactType?: string | undefined;
    fieldType?: string | undefined;
}

export interface Void {
}

export interface BookmarkFields {
    tableName?: string | undefined;
    fields?: string[] | undefined;
}

export interface UserContact {
    id?: number;
    orderNumber?: number;
    userProfileId?: number;
    name?: string;
    email?: string;
    title?: string;
}

export interface ContactList {
    id?: number;
    userProfileId?: string;
    orderNumber?: number;
    title?: string;
}

export interface ReturnCode {
    id?: number;
    code?: string | undefined;
    reason?: string | undefined;
}

export interface ShortcutLink {
    id?: number;
    label?: string;
    shortcutLinkUrl?: string;
    orderNumber?: number;
}

export interface SubrecipientQuestion {
    id?: number;
    sequenceNumber?: number;
    question?: string | undefined;
    isActive?: boolean;
}

export interface SubrecipientStatusVm {
    id?: number;
    statusCode?: string;
    statusDescription?: string;
    statusActionSource?: string;
    statusType?: string;
    isActive?: boolean;
    createdDate?: Date;
    createdBy?: string | undefined;
    modifiedDate?: Date;
    modifiedBy?: string;
}

export interface Training {
    id?: number;
    label?: string;
    trainingFileId?: string;
    fileName?: string;
    orderNumber?: number;
}

export interface UtilityTableLookupVm {
    id?: number;
    tableName?: string;
    tableDescription?: string;
}

export interface LookupItemsResponse {
    lookupItems?: LookupItem[] | undefined;
    utilityTableKey?: UtilityTableKeyEnum | undefined;
}

export interface LookupItem {
    id?: number | undefined;
    key?: string;
    value?: string;
}

export enum UtilityTableKeyEnum {
    AppFeatureLookup = "AppFeatureLookup",
    CountryCodeLookup = "CountryCodeLookup",
    InstitutionTypeLookup = "InstitutionTypeLookup",
    UserRoleLookup = "UserRoleLookup",
    RolePermissionLookup = "RolePermissionLookup",
    StateCodeLookup = "StateCodeLookup",
}

export interface LookupItemResponse {
    lookupItem?: LookupItem | undefined;
    utilityTableKey?: UtilityTableKeyEnum | undefined;
}

export interface WashUContacts {
    contacts?: WashUContact[];
    id?: number;
    status?: string | undefined;
    institutionName?: string | undefined;
    institutionAddress?: Address;
    osrsAddress?: Address;
}

export interface InstitutionContact {
    title?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nameSuffix?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    email?: string | undefined;
    address?: Address;
}

export interface WashUContact extends InstitutionContact {
    contactType?: string | undefined;
    description?: string | undefined;
}

export interface Address {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
}

export interface UserProfileViewModel {
    id?: number;
    wustlId?: number | undefined;
    employeeName?: string | undefined;
    role?: string | undefined;
    email?: string | undefined;
    isActive?: boolean | undefined;
    dateOfAction?: Date | undefined;
    notes?: string | undefined;
    signatureFileId?: string | undefined;
    signatureFileName?: string | undefined;
    permissions?: string[] | undefined;
    jobTitle?: string | undefined;
}

export interface RolePermissionsViewModel {
    role?: string | undefined;
    permissions?: string[] | undefined;
}

export interface UserProfileUpdate {
    wustlId?: number | undefined;
    employeeName?: string | undefined;
    email?: string | undefined;
    jobTitle?: string | undefined;
}

export interface Subaward {
    id?: number | undefined;
    washUInformation?: SubrecipientWashUInformation | undefined;
    subrecipientInformation?: SubrecipientInformation | undefined;
    contact?: SubawardContact | undefined;
    comments?: SubrecipientComment[] | undefined;
    additionalDocuments?: AdditionalDocument[] | undefined;
    auditLogs?: SubrecipientAuditLog[] | undefined;
    institutionOfficers?: InstitutionOfficerVm[] | undefined;
    contractAttachments?: SubrecipientContractAttachment[] | undefined;
    ffataDescription?: string | undefined;
    approved?: boolean | undefined;
    internalDistributionSent?: boolean | undefined;
    unilateralModSent?: boolean | undefined;
    poNotificationSent?: boolean | undefined;
    fullyExecutedAgreement?: FullyExecutedAgreement | undefined;
    subrecipientMonitoringQuestions?: SubrecipientMonitoringQuestion[] | undefined;
    modType?: string | undefined;
}

export interface SubrecipientWashUInformation {
    projectId?: number | undefined;
    subawardId?: number | undefined;
    proposalId?: string | undefined;
    awardDepartment?: string | undefined;
    awardNumber?: string | undefined;
    awardYear?: number | undefined;
    amendment?: number | undefined;
    status?: string | undefined;
    sponsorName?: string | undefined;
    originatingSponsor?: string | undefined;
    wuPrincipalInvestigator?: string | undefined;
    awardDepartmentName?: string | undefined;
    issuingDepartment?: string | undefined;
    fund?: string | undefined;
    subClass?: string | undefined;
    issuingFundSubClassBudgetObject?: string | undefined;
    departmentName?: string | undefined;
    grantWorkTag?: string | undefined;
    costCenterId?: string | undefined;
    costCenterName?: string | undefined;
    principalInvestigatorName?: string | undefined;
    poCoDocId?: string | undefined;
    poCoEncumbId?: string | undefined;
    agreementNumber?: string | undefined;
    trackingNumber?: string | undefined;
    signatureDate?: string | undefined;
    subReceived?: string | undefined;
    disclosureCompletionDate?: string | undefined;
    educationModuleCompletionDate?: string | undefined;
    approvalDate?: string | undefined;
    coiPolicy?: boolean | undefined;
    coiPolicyNA?: boolean | undefined;
    coiEmplId?: string | undefined;
    coiEmailSent?: string | undefined;
    debarment?: boolean | undefined;
    exportControl?: boolean | undefined;
    debarmentComments?: string | undefined;
    exportControlComments?: string | undefined;
    debarmentDateCompleted?: string | undefined;
    exportControlDateCompleted?: string | undefined;
    subcontractType?: string | undefined;
    farContract?: boolean | undefined;
    ffataReportable?: boolean | undefined;
    foreignAccessClause?: boolean | undefined;
    otherTransactionalAgreement?: boolean | undefined;
    assignedGA?: string | undefined;
    previousAssignedGA?: string | undefined;
    supplierContractId?: string | undefined;
    terminationEffectiveDate?: string | undefined;
    mediumHighRiskLanguageIncluded?: boolean | undefined;
}

export interface SubrecipientInformation {
    institutionId?: number | undefined;
    institutionName?: string | undefined;
    ein?: string | undefined;
    registeredInSamGov?: boolean | undefined;
    institutionStatus?: string | undefined;
    congressionalDistrict?: string | undefined;
    parentDuns?: string | undefined;
    dunsNumber?: string | undefined;
    uniqueEntityId?: string | undefined;
    supplierId?: string | undefined;
    supplierContractId?: string | undefined;
    foreignInstitution?: boolean | undefined;
    parentCongressionalDistrict?: string | undefined;
    riskCategory?: string | undefined;
    top5Q1?: boolean | undefined;
    top5Q2?: boolean | undefined;
    descriptionOfAction?: string | undefined;
    institutionInformationFileName?: string | undefined;
    institutionInformationFileId?: string | undefined;
    institutionInformationDateUploaded?: string | undefined;
    collaboratorScopeOfWorkFileName?: string | undefined;
    collaboratorScopeOfWorkFileId?: string | undefined;
    collaboratorScopeOfWorkDateUploaded?: string | undefined;
    subawardAdvancePayment?: boolean | undefined;
    collaboratorLetterOfIntentFileName?: string | undefined;
    collaboratorLetterOfIntentFileId?: string | undefined;
    dataMgmtSharingPlan?: boolean | undefined;
    dataMgmtSharingPlanFileName?: string | undefined;
    dataMgmtSharingPlanFileId?: string | undefined;
    dataMgmtSharingPlanUploadedDate?: string | undefined;
    dataMgmtSharingPlanUploadedBy?: string | undefined;
    humanSubjects?: boolean | undefined;
    animalSubjects?: boolean | undefined;
    mpiPlan?: boolean | undefined;
    collaboratorMpiFileName?: string | undefined;
    collaboratorMpiFileId?: string | undefined;
    collaboratorMpiDateUploaded?: string | undefined;
    collaboratorMpiUploadedBy?: string | undefined;
    scopeOfWorkChanged?: boolean | undefined;
    fundNumberChanged?: boolean | undefined;
    clinicalResearch?: boolean | undefined;
    submittedDate?: Date | undefined;
    address?: Address2 | undefined;
    placeOfPerformance?: SubrecipientPlaceOfPerformance | undefined;
    budget?: SubrecipientBudget | undefined;
    hasKeyPersonnel?: boolean | undefined;
}

export interface Address2 {
    addressLine1?: string | undefined;
    addressLine2?: string | undefined;
    addressLine3?: string | undefined;
    addressLine4?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    province?: string | undefined;
    congressionalDistrict?: string | undefined;
}

export interface SubrecipientPlaceOfPerformance {
    subrecipientId?: number | undefined;
    institutionName?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    emailAddress?: string | undefined;
    address?: Address2;
    placeDiffersFromContactsPage?: boolean | undefined;
}

export interface SubrecipientBudget {
    sameAsGrantPeriod?: boolean | undefined;
    budgetFromDate?: string | undefined;
    budgetThruDate?: string | undefined;
    estimatedProjectPeriodFromDate?: string | undefined;
    estimatedProjectPeriodToDate?: string | undefined;
    costSharingAmount?: string | undefined;
    indirectCost?: string | undefined;
    directCost?: string | undefined;
    estimatedTotalFunding?: string | undefined;
    fAndARate?: string | undefined;
    indirectCostBaseMethod?: string | undefined;
    indirectCostBaseMethodDesc?: string | undefined;
    fAndARateAgreementFileName?: string | undefined;
    fAndARateAgreementFileId?: string | undefined;
    fAndARateAgreementUploadedDate?: string | undefined;
}

export interface SubawardContact {
    subrecipientId?: number | undefined;
    centralOfficeEmail?: string | undefined;
    departmentalAdmin?: SubrecipientContact | undefined;
    principalInvestigator?: SubrecipientContact | undefined;
    signatory?: SubrecipientContact | undefined;
    institutionalAdmin?: SubrecipientContact | undefined;
    institutionalFinancial?: SubrecipientContact | undefined;
    washUPrincipalInvestigator?: SubrecipientContact | undefined;
    washUDepartmentAdmin?: SubrecipientContact | undefined;
    keyPersonnel?: KeyPersonnel | undefined;
}

export interface SubrecipientContact {
    id?: number | undefined;
    subrecipientId?: number | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    nameSuffix?: string | undefined;
    primaryDivision?: string | undefined;
    phone?: string | undefined;
    fax?: string | undefined;
    emailAddress?: string | undefined;
    invoiceEmail?: string | undefined;
    address?: Address2 | undefined;
    campusCD?: string | undefined;
    campusBox?: string | undefined;
    principalInvestigatorDepartment?: string | undefined;
    deptName?: string | undefined;
    collaboratingPrincipalInvestigatorDepartment?: string | undefined;
    jobTitle?: string | undefined;
    contactType?: string | undefined;
}

export interface KeyPersonnel {
    fullNames?: FullNames[] | undefined;
    hasKeyPersonnel?: boolean | undefined;
}

export interface FullNames {
    fullName?: string | undefined;
}

export interface SubrecipientComment {
    id?: number | undefined;
    subrecipientId?: number | undefined;
    created?: string;
    createdBy?: string | undefined;
    comment?: string | undefined;
    returnCode?: string | undefined;
}

export interface AdditionalDocument {
    id?: number | undefined;
    subrecipientId?: number | undefined;
    included?: boolean;
    dateUploaded?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
}

export interface SubrecipientAuditLog {
    id?: number | undefined;
    subrecipientId?: number | undefined;
    created?: Date | undefined;
    createdBy?: string | undefined;
    action?: string | undefined;
    description?: string | undefined;
}

export interface InstitutionOfficerVm {
    id?: number;
    institutionId?: number;
    subrecipientId?: number;
    officerName?: string;
    compensation?: number | undefined;
    isActive?: boolean;
    createdDate?: Date;
    createdBy?: string;
    modifiedDate?: Date;
    modifiedBy?: string;
}

export interface SubrecipientContractAttachment {
    id?: number | undefined;
    subrecipientId?: number | undefined;
    fileName?: string | undefined;
    fileId?: string | undefined;
    fullAgreement?: boolean | undefined;
    source?: string | undefined;
    signaturePage?: boolean | undefined;
    signed?: boolean | undefined;
    sequence?: string | undefined;
    created?: string;
    unilateral?: string | undefined;
    utilitiesAttachmentTemplateId?: number | undefined;
}

export interface FullyExecutedAgreement {
    id?: number | undefined;
    subrecipientId?: number | undefined;
    dateUploaded?: string | undefined;
    fileId?: string | undefined;
    fileName?: string | undefined;
}

export interface SubrecipientMonitoringQuestion {
    id?: number | undefined;
    subrecipientId?: number | undefined;
    sequence?: number | undefined;
    answer?: boolean | undefined;
    question?: string | undefined;
}

export interface ManageSubawardResponse {
    subaward?: Subaward;
    warnings?: Warning[] | undefined;
}

export interface Warning {
    warningMessageKey?: string;
    warningMessageTitle?: string;
    warningMessageBody?: string;
}

export interface PopulateAttachmentResult {
    id?: number | undefined;
    attachmentName?: string | undefined;
    file?: File | undefined;
    invalidBookmarks?: string[];
    emptyBookmarks?: string[];
    unilateral?: string | undefined;
    utilitiesAttachmentTemplateId?: number | undefined;
}

export interface File {
    id?: string;
}

export interface GenerateFullAgreementPdfResponse {
    jobId?: string;
}

export interface NoSignatureResponse {
    statusCode?: number;
    error?: string;
    errorType?: string;
}

export interface GrantsResponse {
    costCenterId?: string | undefined;
    costCenterName?: string | undefined;
    grantWorkTag?: string | undefined;
    washUPiContact?: SubrecipientContact;
    warnings?: Warning[] | undefined;
}

export interface CchRollupReportResponse {
    submittedAndExecutedByCchRollup?: CchRollupReportViewModel[];
    submittedAndExecutedByFIS?: CchRollupFISReportViewModel[];
    grandTotalSubmitted?: number | undefined;
    grandTotalExecuted?: number | undefined;
    fisGrandTotalSubmitted?: number | undefined;
    fisGrandTotalExecuted?: number | undefined;
}

export interface CchRollupReportViewModel {
    cchRollup?: string;
    cchRollupName?: string;
    fisLegacyDeptNumber?: string;
    fisLegacyDeptName?: string;
    totalSubmitted?: number | undefined;
    newExecuted?: number | undefined;
    modsExecuted?: number | undefined;
    totalExecuted?: number | undefined;
}

export interface CchRollupFISReportViewModel {
    cchRollup?: string;
    cchRollupName?: string;
    fisLegacyDeptNumber?: string;
    fisLegacyDeptName?: string;
    totalSubmitted?: number | undefined;
    newExecuted?: number | undefined;
    modsExecuted?: number | undefined;
    totalExecuted?: number | undefined;
}

export interface CollaboratorsExecutedSubsViewModel {
    institutionCountry?: string | undefined;
    subDistributionDate?: Date | undefined;
    sponsorAwardNumber?: string | undefined;
    foreignMaterialsAccess?: boolean | undefined;
    sponsorName?: string | undefined;
    projectTitle?: string | undefined;
    washUAgreementNumber?: string | undefined;
    washUPIName?: string | undefined;
    collaboratorPICountry?: string | undefined;
    collaboratorName?: string | undefined;
    collaboratorPIName?: string | undefined;
    collaboratorPIEmailAddress?: string | undefined;
    distributedSubAwardCount?: number | undefined;
    totalFoundedAmount?: number | undefined;
    grantWorkTag?: string | undefined;
    supplierContractId?: string | undefined;
}

export interface COWorklistViewModel {
    subrecipientId?: number;
    priority?: boolean | undefined;
    status?: string | undefined;
    lastStatusChangedDate?: Date | undefined;
    submittedDate?: Date | undefined;
    originalSubmittedDate?: Date | undefined;
    budgetFromDate?: Date | undefined;
    subrecipient?: string | undefined;
    totalCostsThisAction?: number | undefined;
    wupiLastName?: string | undefined;
    wupiFirstName?: string | undefined;
    assignedGA?: string | undefined;
    proposalId?: string | undefined;
    awardDept?: string | undefined;
    issuingDept?: string | undefined;
    grantWorkTag?: string | undefined;
    costCenterId?: string | undefined;
    awardYear?: number | undefined;
    agreementNumber?: string | undefined;
    trackingNumber?: string | undefined;
    foreignEntity?: string | undefined;
    subcontractType?: string | undefined;
    repeatedSubmission?: boolean | undefined;
}

export interface DAWorklistViewModel {
    subrecipientId?: number;
    proposalId?: string | undefined;
    wupiLastName?: string | undefined;
    wupiFirstName?: string | undefined;
    assignedGA?: string | undefined;
    sponsorName?: string | undefined;
    poNumber?: string | undefined;
    grantWorkTag?: string | undefined;
    costCenterId?: string | undefined;
    awardYear?: number | undefined;
    subrecipient?: string | undefined;
    subPILastName?: string | undefined;
    status?: string | undefined;
    submittedDate?: Date | undefined;
    returnedDate?: Date | undefined;
    awardDept?: string | undefined;
    agreementNumber?: string | undefined;
    trackingNumber?: string | undefined;
    foreignEntity?: string | undefined;
    needAdvancePayment?: string | undefined;
    budgetThrough?: Date | undefined;
}

export interface InstitutionAuditReportResponse {
    newInstitutions?: NewInstitutionReportModel[];
    completedInstitutions?: NewInstitutionReportModel[];
    institutionAuditLogs?: InstitutionAuditReportModel[];
    subInstitutionFCOIPolicies?: InstitutionFCOIReportModel[];
}

export interface InstitutionReportBaseModel {
    institutionId?: number | undefined;
    dunsNumber?: string;
    uniqueEntityId?: string;
    institutionName?: string;
    riskCategory?: string;
    supplierId?: string;
    foreign?: string;
    status?: string;
    createdBy?: string;
    createdDate?: Date | undefined;
}

export interface NewInstitutionReportModel extends InstitutionReportBaseModel {
}

export interface InstitutionAuditReportModel extends InstitutionReportBaseModel {
    entityType?: string;
    addressType?: string;
    contactType?: string;
    fieldName?: string;
    fieldOldValue?: string;
    fieldNewValue?: string;
}

export interface InstitutionFCOIReportModel extends InstitutionReportBaseModel {
    fcoiPolicy?: string;
    agreementNumber?: string;
    proposalId?: string;
}

export interface NewInstitutionReportResponse {
    newInstitutions?: NewInstitutionReportModel[];
    completedInstitutions?: NewInstitutionReportModel[];
}

export interface OsrsReviewReportResponse {
    totalSubsCount?: number | undefined;
    avgDaysAtOsrsReview?: number | undefined;
    subs?: OsrsReviewReportViewModel[];
}

export interface OsrsReviewReportViewModel {
    subrecipientId?: number | undefined;
    subrecipient?: string;
    assignedGA?: string;
    washUPI?: string;
    deptAdmin?: string;
    subawardNumber?: string;
    osrsNotApprovedDate?: Date | undefined;
    pendingApprovalDate?: Date | undefined;
    daysAtOsrsReview?: number | undefined;
}

export interface OutgoingActivityReportModel {
    fy?: number;
    category?: string;
    july?: number;
    august?: number;
    september?: number;
    october?: number;
    november?: number;
    december?: number;
    january?: number;
    february?: number;
    march?: number;
    april?: number;
    may?: number;
    june?: number;
    total?: number;
}

export interface OutgoingSubsStatusViewModel {
    dateFrom?: Date;
    dateTo?: Date;
    submittedToOSRS?: number;
    workInProgress?: number;
    subsReturned?: number;
    sentToSub?: number;
    inactivatedAndVoided?: number;
    distributed?: number;
    deletedSubs?: number;
    assignedGA?: string | undefined;
}

export interface ReturnReportViewModel {
    returnCode?: string | undefined;
    returnReason?: string | undefined;
    subrecipientId?: number | undefined;
    subrecipient?: string | undefined;
    washUPI?: string | undefined;
    wupiLastName?: string | undefined;
    assignedGA?: string | undefined;
    deptAdmin?: string | undefined;
    proposalId?: string | undefined;
    agreementNumber?: string | undefined;
    rdaDate?: Date | undefined;
    osrsDate?: Date | undefined;
    oboDate?: Date | undefined;
    stsDate?: Date | undefined;
    daysAtDept?: string | undefined;
    daysAtOSRSDept?: string | undefined;
    daysBtwnSTSandOBO?: string | undefined;
    subsCount?: number | undefined;
}

export interface SentDistFFATAReportViewModel {
    subawardNumber?: string | undefined;
    subcontractType?: string | undefined;
    washUPI?: string | undefined;
    assignedGA?: string | undefined;
    dateSubmittedToOSRS?: Date | undefined;
    dateOpenedByOSRS?: Date | undefined;
    pendingApproval?: Date | undefined;
    dateSentToSub?: Date | undefined;
    dateSubReceived?: Date | undefined;
    dateDistributedToSub?: Date | undefined;
    nameOfSubrecipient?: string | undefined;
    pendingOSRSReview?: number | undefined;
    osrsProcessingTime?: number | undefined;
    sentToSub?: number | undefined;
    distributedToSub?: number | undefined;
    daysInNegotiationToSubReceived?: number | undefined;
    daysInNegotiationToSubDistributed?: number | undefined;
    hasNegotiationAuditRecords?: number | undefined;
    fundNumber?: string | undefined;
}

export interface TerminationsPerEOReportViewModel {
    sponsorName?: string | undefined;
    agencyAwardNumber?: string | undefined;
    federalAwardId?: string | undefined;
    proposalId?: string | undefined;
    wuPrincipalInvestigator?: string | undefined;
    agreementNumber?: string | undefined;
    institutionName?: string | undefined;
    grantWorkTag?: string | undefined;
    supplierContractId?: string | undefined;
    washuDARA?: string | undefined;
    terminationEffectiveDate?: Date | undefined;
    dateSentToSub?: Date | undefined;
    dateStatusChangedToTEO?: Date | undefined;
}

export interface ProposalModel {
    proposalId?: string;
    awardNumber?: string;
    awardDepartment?: string;
    awardFundNumber?: string;
    sponsorType?: string;
    sponsorName?: string;
    originatingSponsor?: string;
    projectTitle?: string;
    investigatorEmployeeId?: string;
    investigatorFirstName?: string;
    investigatorLastName?: string;
    investigatorEmail?: string;
    investigatorCampusCode?: string;
    investigatorDept?: string;
    investigatorCampusBox?: string;
    investigatorDeptName?: string;
}

export interface GetProject {
    id?: number;
    projectGroupId?: number;
    proposalId?: string | undefined;
    awardNumber?: string | undefined;
    awardFundNumber?: string | undefined;
    awardYear?: number | undefined;
    awardDepartment?: string | undefined;
    stimulusAwarded?: boolean | undefined;
    researchAndDevelopment?: boolean | undefined;
    sponsorType?: string | undefined;
    sponsorName?: string | undefined;
    originatingSponsor?: string | undefined;
    projectTitle?: string | undefined;
    grantFromDate?: string | undefined;
    grantThruDate?: string | undefined;
    investigatorEmployeeId?: string | undefined;
    investigatorFirstName?: string | undefined;
    investigatorLastName?: string | undefined;
    investigatorEmail?: string | undefined;
    investigatorCampusCode?: string | undefined;
    investigatorDept?: string | undefined;
    investigatorDeptName?: string | undefined;
    investigatorCampusBox?: string | undefined;
    adminPhone?: string | undefined;
    adminFax?: string | undefined;
    adminEmail?: string | undefined;
    adminEmployeeId?: string | undefined;
    adminFirstName?: string | undefined;
    adminLastName?: string | undefined;
    federalAwardId?: string | undefined;
    subrecipients?: SubawardSummary[] | undefined;
    noticeOfAwards?: GetNoticeOfAward[];
    awardYears?: GetAwardYear[];
}

export interface SubawardSummary {
    id?: number;
    issuingDepartment?: string | undefined;
    institutionName?: string | undefined;
    issuingFund?: string | undefined;
    grantWorkTag?: string | undefined;
    submittedDate?: Date | undefined;
    amendmentNumber?: number | undefined;
    agreementNumber?: string | undefined;
    trackingNumber?: string | undefined;
    status?: string | undefined;
}

export interface GetNoticeOfAward {
    id?: number;
    selected?: boolean;
    dateUploaded?: string;
    uploadedBy?: string;
    fileId?: string;
    fileName?: string;
}

export interface GetAwardYear {
    awardYear?: number | undefined;
    projectId?: number;
}

export interface PostProjectViewModel {
    proposalId?: string | undefined;
    awardNumber?: string | undefined;
    awardFundNumber?: string | undefined;
    awardYear?: number | undefined;
    awardDepartment?: string | undefined;
    stimulusAwarded?: boolean | undefined;
    researchAndDevelopment?: boolean | undefined;
    sponsorType?: string | undefined;
    sponsorName?: string | undefined;
    originatingSponsor?: string | undefined;
    projectTitle?: string | undefined;
    grantFromDate?: string | undefined;
    grantThruDate?: string | undefined;
    investigatorEmployeeId?: string | undefined;
    investigatorFirstName?: string | undefined;
    investigatorLastName?: string | undefined;
    investigatorEmail?: string | undefined;
    investigatorCampusCode?: string | undefined;
    investigatorDept?: string | undefined;
    investigatorDeptName?: string | undefined;
    investigatorCampusBox?: string | undefined;
    adminPhone?: string | undefined;
    adminFax?: string | undefined;
    adminEmail?: string | undefined;
    adminEmployeeId?: string | undefined;
    adminFirstName?: string | undefined;
    adminLastName?: string | undefined;
    federalAwardId?: string | undefined;
    noticeOfAwards?: PostNoticeOfAward[];
}

export interface PostNoticeOfAward {
    id?: number | undefined;
    selected?: boolean;
    dateUploaded?: string;
    uploadedBy?: string;
    fileId?: string;
}

export interface ProjectSearchResult {
    id?: number;
    subAwardId?: number | undefined;
    proposalId?: string | undefined;
    investigatorLastName?: string | undefined;
    investigatorFirstName?: string | undefined;
    issuingDept?: string | undefined;
    grantWorkTag?: string | undefined;
    costCenterId?: string | undefined;
    awardNumber?: string | undefined;
    awardYear?: number | undefined;
    amendment?: number | undefined;
    subrecipient?: string | undefined;
    budgetObject?: string | undefined;
    poNumber?: string | undefined;
    subFromDate?: Date | undefined;
    subThruDate?: Date | undefined;
    totalCost?: number | undefined;
    subInvestigatorLastName?: string | undefined;
    subInvestigatorFirstName?: string | undefined;
    agreementNumber?: string | undefined;
    trackingNumber?: string | undefined;
    subStatus?: string | undefined;
    sponsor?: string | undefined;
    riskCategory?: string | undefined;
    countryName?: string | undefined;
    supplierContractId?: string | undefined;
    foreignEntity?: string | undefined;
}

export interface Institution {
    id?: number | undefined;
    institutionName?: string | undefined;
    status?: InstitutionStatus;
    institutionType?: string | undefined;
    dunsNumber?: string | undefined;
    congressionalDistrict?: string | undefined;
    samGov?: boolean | undefined;
    foreign?: boolean | undefined;
    primaryInstitution?: boolean | undefined;
    top5Q1?: boolean | undefined;
    top5Q2?: boolean | undefined;
    parentDuns?: string | undefined;
    parentCongressionalDistrict?: string | undefined;
    employerIdNumber?: string | undefined;
    riskCategory?: string | undefined;
    uniqueEntityId?: string | undefined;
    supplierId?: string | undefined;
    centralOfficeEmail?: string | undefined;
    comments?: string | undefined;
    samGovFileId?: string | undefined;
    samGovFileName?: string | undefined;
    isDeleted?: boolean | undefined;
    institutionAddress?: Address;
    signatory?: InstitutionContact;
    adminPointOfContact?: InstitutionContact;
    financeContact?: InstitutionFinancialContact;
    auditLogs?: InstitutionAuditLogVm[] | undefined;
    institutionOfficers?: InstitutionOfficerVm[] | undefined;
}

export enum InstitutionStatus {
    IP = "IP",
    C = "C",
}

export interface InstitutionFinancialContact extends InstitutionContact {
    invoiceEmail?: string | undefined;
}

export interface InstitutionAuditLogVm {
    id?: number;
    institutionId?: number;
    institutionName?: string;
    created?: Date;
    createdBy?: string;
    action?: InstitutionAction;
    entityType?: string;
    addressType?: string;
    contactType?: string;
    fieldName?: string;
    fieldOldValue?: string;
    fieldNewValue?: string;
}

export enum InstitutionAction {
    New = "New",
    Mod = "Mod",
    Del = "Del",
}

export interface FileSize {
    sizeBytes?: number;
}

export interface GetEmployeesResponse {
    employeeId?: string | undefined;
    employeeUniversalId?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    primaryDepartment?: string | undefined;
    commonEmail?: string | undefined;
    campusCode?: string | undefined;
    campusBox?: string | undefined;
    phone?: string | undefined;
    jobTitle?: string | undefined;
}

export interface EmailSizeLimitResponse {
    sizeLimitMb?: number;
}

export interface FinancialRiskEmail {
    fromEmail?: string | undefined;
    dunsNumber?: string | undefined;
    uei?: string | undefined;
    subrecipient?: string | undefined;
    subFinancialContactFirstName?: string | undefined;
    subFinancialContactLastName?: string | undefined;
    subFinancialContactEmail?: string | undefined;
    wuDeptAdminFirstName?: string | undefined;
    washUPrincipalInvestigatorEmail?: string | undefined;
}

export interface FCOIEmailRequest {
    washUPI?: string;
    washUDA?: string;
    subPI?: string;
    subAdmin?: string;
    centralAdminEmail?: string | undefined;
    agreementNumber?: string;
    institutionName?: string | undefined;
}

export interface ReturnedToDAEmail {
    fromEmail?: string | undefined;
    toEmail?: string | undefined;
    proposalId?: string;
    issuingFund?: string | undefined;
    washUDepartmentAdminFullName?: string | undefined;
    washUPrincipalInvestigatorFullName?: string | undefined;
    subPrincipalInvestigatorFullName?: string | undefined;
    awardYear?: number | undefined;
    institutionId?: number;
    institutionName?: string | undefined;
    issuingDepartment?: string | undefined;
    grantWorktag?: string | undefined;
    costCenter?: string | undefined;
    costCenterName?: string | undefined;
    budget?: string | undefined;
    amendmentNumber?: number | undefined;
    returnCode?: string | undefined;
    returnReason?: string | undefined;
    returnComment?: string | undefined;
}

export interface NotApprovedToGAEmail {
    fromEmail?: string | undefined;
    toEmail?: string | undefined;
    agreementNumber?: string | undefined;
    washUOSRSGAFullName?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}